// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.how-it-works-page {
  font-family: "Open Sans", sans-serif !important;
  color: #ffffff;
  line-height: 1.6;
  overflow-x: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  margin-top: 0 !important;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}
.how-it-works-page .main-container {
  margin-top: 0 !important;
  padding-top: 0 !important;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.how-it-works-page .material-symbols-outlined {
  font-family: "Material Symbols Outlined" !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-size: 24px !important;
  line-height: 1 !important;
  letter-spacing: normal !important;
  text-transform: none !important;
  display: inline-block !important;
  white-space: nowrap !important;
  word-wrap: normal !important;
  direction: ltr !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.how-it-works-page .page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  margin-top: 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  background: rgba(10, 12, 16, 0.95);
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.how-it-works-page .page-header ~ :global(.flow-sidebar) {
  z-index: 1001 !important;
}
.how-it-works-page .page-header.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  background: rgba(10, 12, 16, 0.98);
}
.how-it-works-page .page-header .header-container {
  max-width: 100%;
  width: 100%;
  padding: 0 16px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
@media (max-width: 768px) {
  .how-it-works-page .page-header .header-container {
    padding: 0 16px;
    gap: 16px;
    height: 56px;
  }
}
.how-it-works-page .page-header .header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  margin-right: 0;
}
.how-it-works-page .page-header .menu-button {
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}
.how-it-works-page .page-header .menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.how-it-works-page .page-header .menu-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.how-it-works-page .page-header .header-logo {
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.how-it-works-page .page-header .header-logo img {
  height: 45px;
  width: auto;
  display: block;
}
@media (max-width: 768px) {
  .how-it-works-page .page-header .header-logo img {
    height: 35px;
  }
}
.how-it-works-page .page-header .header-nav {
  display: flex;
  align-items: center;
  gap: 40px;
  flex: 1;
  justify-content: center;
  min-width: 0;
  margin: 0 auto;
}
@media (max-width: 1024px) {
  .how-it-works-page .page-header .header-nav {
    gap: 24px;
  }
}
@media (max-width: 768px) {
  .how-it-works-page .page-header .header-nav {
    display: none;
  }
}
.how-it-works-page .page-header .header-nav .nav-link {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  padding: 4px 0;
}
.how-it-works-page .page-header .header-nav .nav-link:hover {
  color: #ffffff;
}
.how-it-works-page .page-header .header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-shrink: 0;
}
.how-it-works-page .page-header .theme-toggle-button {
  border-radius: 999px;
  padding: 2px;
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  cursor: pointer;
}
.how-it-works-page .page-header .theme-toggle-button:focus, .how-it-works-page .page-header .theme-toggle-button:active, .how-it-works-page .page-header .theme-toggle-button:focus-visible {
  border: none;
  outline: none;
  box-shadow: none;
}
.how-it-works-page .page-header .theme-toggle-button:hover {
  background: transparent;
}
.how-it-works-page .page-header .theme-toggle-track {
  width: 48px;
  height: 26px;
  border-radius: 999px;
  background: #e5e7eb;
  border: none;
  display: inline-flex;
  align-items: center;
  padding: 1px;
  transition: background-color 0.2s ease;
}
.how-it-works-page .page-header .theme-toggle-track.active {
  background: #1f2937;
}
.how-it-works-page .page-header .theme-toggle-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateX(0);
  transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;
}
.how-it-works-page .page-header .theme-toggle-track.active .theme-toggle-thumb {
  transform: translateX(22px);
  color: #ffffff;
  background: #0f172a;
}
.how-it-works-page .page-header .theme-toggle-thumb mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.how-it-works-page .page-header .theme-toggle-track.active .theme-toggle-thumb mat-icon {
  color: #ffffff !important;
}
.how-it-works-page .page-header .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {
  color: #6b7280 !important;
}
.how-it-works-page .page-header .btn-get-started {
  background: #ffffff;
  color: #000000;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-left: 0;
}
.how-it-works-page .page-header .btn-get-started:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
  .how-it-works-page .page-header .btn-get-started {
    padding: 8px 16px;
    font-size: 12px;
  }
}
.how-it-works-page .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
@media (max-width: 768px) {
  .how-it-works-page .container {
    padding: 0 16px;
    overflow-x: hidden;
  }
}
.how-it-works-page .section {
  padding: 80px 0;
  position: relative;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  will-change: opacity, transform;
}
.how-it-works-page .section.animate-in {
  opacity: 1;
  transform: translateY(0);
}
.how-it-works-page .hero-section {
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  color: #ffffff;
  text-align: center;
  padding: 40px 24px 120px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  transform: none;
}
@media (max-width: 768px) {
  .how-it-works-page .hero-section {
    padding: 32px 24px 80px;
    margin-top: 10px;
  }
}
.how-it-works-page .hero-section .hero-radial-gradient {
  position: absolute;
  inset: 0;
  z-index: 0;
  opacity: 0.2;
  pointer-events: none;
  background: radial-gradient(circle at 50% 50%, #5ea1d8 0%, transparent 50%);
}
.how-it-works-page .hero-section .hero-decorative-line {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(94, 161, 216, 0.5), transparent);
}
.how-it-works-page .hero-section .hero-content {
  max-width: 1024px;
  padding: 0 24px;
  position: relative;
  z-index: 2;
  background: transparent;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  margin-top: 0;
}
.how-it-works-page .hero-section .hero-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 48px;
  font-weight: 900;
  line-height: 1.2;
  margin: 0 auto 24px;
  letter-spacing: -0.02em;
  color: #ffffff;
  animation: fadeInUp 0.8s ease-out;
  max-width: 672px;
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
}
.how-it-works-page .hero-section .hero-title .highlight-blue {
  color: #5ea1d8;
}
@media (min-width: 768px) {
  .how-it-works-page .hero-section .hero-title {
    font-size: 72px;
    line-height: 1.15;
  }
}
.how-it-works-page .hero-section .hero-description {
  font-size: 18px !important;
  line-height: 1.8 !important;
  margin: 0 auto !important;
  color: rgb(148, 163, 184) !important;
  max-width: 672px;
  width: 100%;
  animation: fadeInUp 0.8s ease-out 0.2s both;
  font-weight: 400 !important;
}
@media (min-width: 768px) {
  .how-it-works-page .hero-section .hero-description {
    font-size: 20px !important;
  }
}
.how-it-works-page .hero-section .hero-cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  animation: fadeInUp 0.8s ease-out 0.4s both;
  width: 100%;
}
@media (min-width: 640px) {
  .how-it-works-page .hero-section .hero-cta-buttons {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}
.how-it-works-page .hero-section .btn-primary-hero {
  background: #5ea1d8;
  color: #ffffff;
  border: none;
  padding: 16px 32px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Open Sans", sans-serif !important;
  box-shadow: 0 10px 25px rgba(94, 161, 216, 0.2);
  width: 100%;
}
.how-it-works-page .hero-section .btn-primary-hero:hover {
  transform: scale(1.05);
}
@media (min-width: 640px) {
  .how-it-works-page .hero-section .btn-primary-hero {
    width: auto;
  }
}
.how-it-works-page .hero-section .btn-secondary-hero {
  background: #ffffff;
  color: #212427;
  border: 1px solid rgb(226, 232, 240);
  padding: 16px 32px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Open Sans", sans-serif !important;
  width: 100%;
}
.how-it-works-page .hero-section .btn-secondary-hero:hover {
  background: rgb(248, 250, 252);
}
@media (min-width: 640px) {
  .how-it-works-page .hero-section .btn-secondary-hero {
    width: auto;
  }
}
.how-it-works-page .hero-section .btn-watch-demo {
  background: transparent;
  color: #5ea1d8;
  border: 2px solid #5ea1d8;
  padding: 16px 32px;
  font-size: 18px;
  font-weight: 700;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Open Sans", sans-serif !important;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  width: 100%;
}
.how-it-works-page .hero-section .btn-watch-demo mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.how-it-works-page .hero-section .btn-watch-demo:hover {
  background: rgba(94, 161, 216, 0.1);
  transform: scale(1.05);
}
@media (min-width: 640px) {
  .how-it-works-page .hero-section .btn-watch-demo {
    width: auto;
  }
}
.how-it-works-page .six-step-flow-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  padding: 96px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .how-it-works-page .six-step-flow-section {
    padding: 60px 16px;
    overflow-x: hidden;
  }
}
.how-it-works-page .six-step-flow-section .container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.how-it-works-page .six-step-flow-section .section-main-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 48px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0 0 16px 0;
  letter-spacing: -0.5px;
}
@media (max-width: 768px) {
  .how-it-works-page .six-step-flow-section .section-main-title {
    font-size: 36px;
  }
}
.how-it-works-page .six-step-flow-section .title-underline {
  width: 96px;
  height: 6px;
  background: #5ea1d8;
  margin: 0 auto;
  border-radius: 9999px;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container {
  position: relative;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  gap: 128px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
@media (max-width: 768px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container {
    margin-top: 40px;
    gap: 64px;
    width: 100%;
    max-width: 100%;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .steps-central-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgb(226, 232, 240);
  transform: translateX(-50%);
  z-index: 0;
  display: none;
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .steps-central-line {
    display: block;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-wrapper {
    display: flex;
    flex-direction: row;
    gap: 96px;
    align-items: center;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item.step-item-left .step-content-wrapper .step-content-text {
    order: 1;
  }
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item.step-item-left .step-content-wrapper .step-content-image {
    order: 2;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item.step-item-right .step-content-wrapper .step-content-text {
    order: 2;
  }
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item.step-item-right .step-content-wrapper .step-content-image {
    order: 1;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-text {
  flex: 1;
  width: 100%;
  max-width: 100%;
  text-align: left;
  align-self: flex-start;
  box-sizing: border-box;
  overflow-x: hidden;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-text {
    display: contents;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-text {
    width: auto;
    max-width: none;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-image {
  flex: 1;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-image {
    order: 2;
    width: 100%;
    max-width: 100%;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-content-image {
    width: auto;
    max-width: none;
    order: unset;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-number {
  font-size: 72px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 16px;
  display: block;
  -webkit-text-stroke: 1px rgba(94, 161, 216, 0.3);
  color: transparent;
  letter-spacing: -2px;
  max-width: 100%;
  box-sizing: border-box;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-number {
    order: 1;
    width: 100%;
    max-width: 100%;
    font-size: 48px;
    margin-bottom: 24px;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
  color: #5ea1d8 !important;
  letter-spacing: -0.3px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-title {
    order: 3;
    width: 100%;
    max-width: 100%;
    font-size: 24px;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-description {
  font-size: 18px;
  line-height: 1.7;
  color: rgb(148, 163, 184) !important;
  margin-bottom: 24px;
  font-weight: 400;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-description {
    order: 4;
    width: 100%;
    max-width: 100%;
    font-size: 16px;
  }
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-description:nth-of-type(2) {
    order: 6;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-list-normal {
  list-style: disc;
  padding-left: 24px;
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-list-normal {
    order: 5;
    width: 100%;
    margin-top: 0;
    margin-bottom: 16px;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-list-normal li {
  font-size: 14px;
  line-height: 1.7;
  color: rgb(148, 163, 184) !important;
  font-weight: 400;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-list-normal li::marker {
  color: #ffffff;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 1023px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-bullets {
    order: 7;
    width: 100%;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-bullets li {
  font-size: 18px;
  line-height: 1.5;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-bullets li .check-icon {
  font-family: "Material Symbols Outlined" !important;
  font-size: 16px !important;
  color: #5ea1d8 !important;
  font-weight: normal !important;
  font-style: normal !important;
  line-height: 1 !important;
  display: inline-block !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-image-card {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16/9;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: transform 0.7s ease;
  background: transparent;
  border: 1px solid rgb(226, 232, 240);
  cursor: pointer;
  box-sizing: border-box;
}
@media (max-width: 768px) {
  .how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-image-card {
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-image-card:hover .step-image-img {
  transform: scale(1.1);
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-image-card .image-overlay {
  display: none;
}
.how-it-works-page .six-step-flow-section .steps-vertical-container .step-item .step-image-card .step-image-img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  mix-blend-mode: normal;
  transition: transform 0.7s ease;
  position: relative;
  z-index: 1;
  display: block;
}
.how-it-works-page .step-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  padding: 80px 0;
  position: relative;
  overflow: hidden;
}
.how-it-works-page .step-section .container {
  position: relative;
  z-index: 1;
}
.how-it-works-page .step-section .step-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 48px;
  position: relative;
}
@media (min-width: 1024px) {
  .how-it-works-page .step-section .step-wrapper {
    flex-direction: row;
    gap: 96px;
    align-items: flex-start;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .step-section .step-wrapper.step-left .step-content-left {
    order: 1;
  }
  .how-it-works-page .step-section .step-wrapper.step-left .step-content-right {
    order: 2;
  }
}
@media (min-width: 1024px) {
  .how-it-works-page .step-section .step-wrapper.step-right .step-content-left {
    order: 2;
  }
  .how-it-works-page .step-section .step-wrapper.step-right .step-content-right {
    order: 1;
  }
}
.how-it-works-page .step-section .step-content-left {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media (min-width: 1024px) {
  .how-it-works-page .step-section .step-content-left {
    width: auto;
  }
}
.how-it-works-page .step-section .step-content-right {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
@media (min-width: 1024px) {
  .how-it-works-page .step-section .step-content-right {
    width: auto;
  }
}
.how-it-works-page .step-section .step-number {
  font-size: 72px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 16px;
  display: block;
  -webkit-text-stroke: 1px rgba(94, 161, 216, 0.3);
  color: transparent;
  letter-spacing: -2px;
}
@media (max-width: 768px) {
  .how-it-works-page .step-section .step-number {
    font-size: 56px;
  }
}
.how-it-works-page .step-section .step-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
  color: #5ea1d8;
  letter-spacing: -0.3px;
}
@media (max-width: 768px) {
  .how-it-works-page .step-section .step-title {
    font-size: 30px;
  }
}
.how-it-works-page .step-section .step-description {
  font-size: 18px;
  line-height: 1.7;
  color: rgb(148, 163, 184) !important;
  margin-bottom: 24px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .how-it-works-page .step-section .step-description {
    font-size: 18px;
  }
}
.how-it-works-page .step-section .step-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.how-it-works-page .step-section .step-bullets li {
  font-size: 18px;
  line-height: 1.5;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
}
.how-it-works-page .step-section .step-bullets li .check-icon {
  font-family: "Material Symbols Outlined" !important;
  font-size: 20px !important;
  color: #5ea1d8 !important;
  font-weight: normal !important;
  font-style: normal !important;
  line-height: 1 !important;
  display: inline-block !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
}
@media (max-width: 768px) {
  .how-it-works-page .step-section .step-bullets li {
    font-size: 16px;
  }
}
.how-it-works-page .step-section .step-image-card {
  width: 100%;
  aspect-ratio: 16/9;
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  position: relative;
  transition: transform 0.7s ease;
}
.how-it-works-page .step-section .step-image-card:hover .step-image-img {
  transform: scale(1.1);
}
.how-it-works-page .step-section .step-image-card .image-overlay {
  display: none;
}
.how-it-works-page .step-section .step-image-card .step-image-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  mix-blend-mode: normal;
  transition: transform 0.7s ease;
  position: relative;
  z-index: 1;
}
.how-it-works-page .stakeholders-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  padding: 96px 24px;
  position: relative;
  color: #ffffff !important;
  overflow: hidden;
}
.how-it-works-page .stakeholders-section .container {
  position: relative;
  z-index: 1;
}
.how-it-works-page .stakeholders-section .section-main-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 30px;
  font-weight: 700;
  color: #ffffff !important;
  margin-bottom: 0;
  margin-top: 0;
  text-align: center;
  letter-spacing: -0.5px;
}
@media (min-width: 768px) {
  .how-it-works-page .stakeholders-section .section-main-title {
    font-size: 36px;
  }
}
.how-it-works-page .stakeholders-section .section-subtitle {
  font-size: 18px;
  display: ruby-text;
  color: rgb(148, 163, 184) !important;
  text-align: center;
  margin-top: 4px;
  margin-bottom: 64px;
  max-width: 672px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.7;
  padding-top: 0;
}
@media (max-width: 768px) {
  .how-it-works-page .stakeholders-section .section-subtitle {
    font-size: 16px;
    margin-bottom: 40px;
  }
}
.how-it-works-page .stakeholders-section .stakeholder-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
@media (max-width: 968px) {
  .how-it-works-page .stakeholders-section .stakeholder-cards {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
.how-it-works-page .stakeholders-section .stakeholder-card {
  background: #101922;
  padding: 32px;
  border-radius: 16px;
  text-align: left;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.how-it-works-page .stakeholders-section .stakeholder-card:hover {
  border-color: rgba(94, 161, 216, 0.5);
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-icon-wrapper {
  width: 48px;
  height: 48px;
  margin-bottom: 24px;
  background: rgba(94, 161, 216, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5ea1d8;
  transition: all 0.3s ease;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-icon-wrapper .material-symbols-outlined {
  font-size: 24px !important;
}
.how-it-works-page .stakeholders-section .stakeholder-card:hover .stakeholder-icon-wrapper {
  background: #5ea1d8;
  color: #ffffff;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff !important;
  margin-bottom: 12px;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-description {
  font-size: 16px;
  line-height: 1.6;
  color: rgb(148, 163, 184) !important;
  margin: 0;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 20px;
  padding: 8px 16px;
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  font-weight: 600;
  color: #5ea1d8;
  background: transparent;
  border: 1px solid rgba(94, 161, 216, 0.5);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn .material-symbols-outlined {
  font-size: 20px !important;
  width: 20px;
  height: 20px;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn:hover {
  background: rgba(94, 161, 216, 0.12);
  border-color: #5ea1d8;
  color: #7eb8e8;
}
.how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn:focus-visible {
  outline: 2px solid #5ea1d8;
  outline-offset: 2px;
}
.how-it-works-page .why-matters-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  padding: 96px 24px;
  position: relative;
  overflow: hidden;
}
.how-it-works-page .why-matters-section .container {
  max-width: 1280px;
  margin: 0 auto;
}
.how-it-works-page .why-matters-section .why-matters-grid {
  grid-template-columns: 1fr;
  gap: 48px;
  position: relative;
  z-index: 1;
}
@media (min-width: 1024px) {
  .how-it-works-page .why-matters-section .why-matters-grid {
    grid-template-columns: 1fr 1fr;
    gap: 48px;
  }
}
.how-it-works-page .why-matters-section .why-card {
  padding: 40px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.how-it-works-page .why-matters-section .why-card.sustainability-card {
  background: rgba(94, 161, 216, 0.05);
  border: 1px solid rgba(94, 161, 216, 0.2);
}
.how-it-works-page .why-matters-section .why-card.precision-card {
  background: rgba(94, 161, 216, 0.05) !important;
  border: 1px solid rgba(94, 161, 216, 0.2) !important;
}
.how-it-works-page .why-matters-section .feature-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #ffffff !important;
  font-weight: 700;
  margin-bottom: 0;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 12px;
}
.how-it-works-page .why-matters-section .feature-header .feature-icon-small {
  font-family: "Material Symbols Outlined" !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
  color: #ffffff !important;
}
.how-it-works-page .why-matters-section .feature-header .feature-label {
  color: #ffffff !important;
}
.how-it-works-page .why-matters-section .why-card-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: revert !important;
  font-weight: 700;
  color: #ffffff !important;
  margin-bottom: 24px;
  letter-spacing: -0.5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.how-it-works-page .why-matters-section .why-card-title .feature-icon-small {
  font-family: "Material Symbols Outlined" !important;
  font-size: 14px !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
  color: #ffffff !important;
}
.how-it-works-page .why-matters-section .why-card-title .feature-label {
  color: #ffffff !important;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 12px;
  font-weight: 700;
}
.how-it-works-page .why-matters-section .why-card-title > span:last-child {
  flex-basis: 100%;
  margin-top: 8px;
}
.how-it-works-page .why-matters-section .why-card-description {
  font-size: 18px;
  line-height: 1.7;
  color: #ffffff !important;
  margin-bottom: 32px;
}
.how-it-works-page .why-matters-section .feature-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
}
.how-it-works-page .why-matters-section .feature-header .feature-icon {
  width: 32px;
  height: 32px;
  background: #5ea1d8;
  border-radius: 4px;
}
.how-it-works-page .why-matters-section .feature-header .feature-icon.leaf-icon {
  clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
}
.how-it-works-page .why-matters-section .section-main-title {
  font-family: "Open Sans", sans-serif !important;
  font-size: 42px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
  letter-spacing: -0.5px;
}
@media (max-width: 768px) {
  .how-it-works-page .why-matters-section .section-main-title {
    font-size: 32px;
  }
}
.how-it-works-page .why-matters-section .feature-description {
  font-size: 18px;
  line-height: 1.7;
  color: #ffffff !important;
  text-align: center;
  max-width: 900px;
  margin: 0 auto 50px;
}
@media (max-width: 768px) {
  .how-it-works-page .why-matters-section .feature-description {
    font-size: 16px;
    margin-bottom: 40px;
  }
}
.how-it-works-page .why-matters-section .feature-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.how-it-works-page .why-matters-section .stat-card {
  background: rgba(255, 255, 255, 0.1);
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.how-it-works-page .why-matters-section .stat-card .stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #5ea1d8 !important;
  margin-bottom: 4px;
  line-height: 1;
}
.how-it-works-page .why-matters-section .stat-card .stat-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6) !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.how-it-works-page .why-matters-section .precision-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 768px) {
  .how-it-works-page .why-matters-section .precision-features {
    grid-template-columns: 1fr;
  }
}
.how-it-works-page .why-matters-section .precision-feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.how-it-works-page .why-matters-section .precision-feature-item .precision-icon {
  font-family: "Material Symbols Outlined" !important;
  font-size: 24px !important;
  color: #5ea1d8 !important;
  font-weight: normal !important;
  font-style: normal !important;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24 !important;
}
.how-it-works-page .why-matters-section .precision-feature-item .precision-text {
  font-weight: 500;
  color: #ffffff !important;
}
.how-it-works-page .why-matters-section .why-matters-microcopy {
  text-align: center;
  font-size: 18px;
  line-height: 1.7;
  color: rgb(148, 163, 184) !important;
  margin-top: 48px !important;
  font-weight: 400;
}
.how-it-works-page .step-header {
  text-align: center;
  margin-bottom: 50px;
}
.how-it-works-page .step-number-large {
  font-size: 80px;
  line-height: 1;
  margin-bottom: 20px;
  display: inline-block;
}
@media (max-width: 768px) {
  .how-it-works-page .step-number-large {
    font-size: 60px;
  }
}
.how-it-works-page .section-heading {
  font-family: "Open Sans", sans-serif !important;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
  text-align: center;
  color: #ffffff !important;
  letter-spacing: -0.5px;
  position: relative;
  padding-bottom: 20px;
}
.how-it-works-page .section-heading::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #5ea1d8;
  border-radius: 2px;
}
@media (max-width: 768px) {
  .how-it-works-page .section-heading {
    font-size: 32px;
    padding-bottom: 15px;
    margin-bottom: 20px;
  }
  .how-it-works-page .section-heading::after {
    width: 40px;
    height: 2px;
  }
}
.how-it-works-page .step-subtitle {
  font-size: 24px;
  font-weight: 400;
  color: #5ea1d8;
  margin-bottom: 40px;
  font-style: italic;
}
@media (max-width: 768px) {
  .how-it-works-page .step-subtitle {
    font-size: 20px;
  }
}
.how-it-works-page .step-content {
  max-width: 900px;
  margin: 0 auto;
}
.how-it-works-page .step-description {
  margin-bottom: 40px;
}
.how-it-works-page .body-copy {
  font-size: 18px;
  line-height: 1.8;
  color: #ffffff !important;
  margin-bottom: 24px;
  text-align: left;
  font-weight: 400;
  max-width: 100%;
}
@media (max-width: 768px) {
  .how-it-works-page .body-copy {
    font-size: 17px;
    line-height: 1.75;
  }
}
.how-it-works-page .step-features {
  list-style: none;
  padding: 0;
  margin: 24px 0;
  text-align: left;
}
.how-it-works-page .step-features li {
  font-size: 18px;
  line-height: 1.8;
  color: #ffffff !important;
  padding: 12px 0 12px 40px;
  position: relative;
}
.how-it-works-page .step-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #5ea1d8 !important;
  font-weight: bold;
  font-size: 20px;
}
@media (max-width: 768px) {
  .how-it-works-page .step-features li {
    font-size: 17px;
    padding: 10px 0 10px 35px;
  }
}
.how-it-works-page .microcopy {
  margin-top: 50px;
  padding: 30px 40px;
  background: rgba(94, 161, 216, 0.08);
  border-left: 4px solid #5ea1d8;
  border-radius: 0 8px 8px 0;
  text-align: center;
}
.how-it-works-page .microcopy p {
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  color: #ffffff !important;
  margin: 0;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .how-it-works-page .microcopy p {
    font-size: 18px;
  }
}

.why-section {
  background: #5ea1d8;
  padding: 100px 0;
  position: relative;
  color: #ffffff;
}
.why-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background-image: repeating-linear-gradient(60deg, transparent, transparent 20px, rgba(255, 255, 255, 0.15) 20px, rgba(255, 255, 255, 0.15) 21px, transparent 21px, transparent 40px), repeating-linear-gradient(-60deg, transparent, transparent 25px, rgba(255, 255, 255, 0.12) 25px, rgba(255, 255, 255, 0.12) 26px, transparent 26px, transparent 50px);
  opacity: 0.6;
  pointer-events: none;
  z-index: 0;
  clip-path: polygon(0 0, 100% 0, 42.3% 100%, 0 100%);
}
.why-section .step-header {
  text-align: center;
  margin-bottom: 50px;
  position: relative;
  z-index: 1;
}
.why-section .step-number-large {
  font-size: 80px;
  line-height: 1;
  margin-bottom: 20px;
  display: inline-block;
}
@media (max-width: 768px) {
  .why-section .step-number-large {
    font-size: 60px;
  }
}
.why-section .section-heading {
  font-family: "Open Sans", sans-serif !important;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
  text-align: center;
  color: #ffffff;
  letter-spacing: -0.5px;
  position: relative;
  padding-bottom: 20px;
}
.why-section .section-heading::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2px;
}
@media (max-width: 768px) {
  .why-section .section-heading {
    font-size: 32px;
    padding-bottom: 15px;
    margin-bottom: 20px;
  }
  .why-section .section-heading::after {
    width: 40px;
    height: 2px;
  }
}
.why-section .step-subtitle {
  font-size: 24px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  font-style: italic;
}
@media (max-width: 768px) {
  .why-section .step-subtitle {
    font-size: 20px;
  }
}
.why-section .step-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.why-section .step-description {
  margin-bottom: 40px;
}
.why-section .body-copy {
  font-size: 18px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 24px;
  text-align: left;
  font-weight: 400;
  max-width: 100%;
}
@media (max-width: 768px) {
  .why-section .body-copy {
    font-size: 17px;
    line-height: 1.75;
  }
}
.why-section .step-features {
  list-style: none;
  padding: 0;
  margin: 24px 0;
  text-align: left;
}
.why-section .step-features li {
  font-size: 18px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.95);
  padding: 12px 0 12px 40px;
  position: relative;
}
.why-section .step-features li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #ffffff;
  font-weight: bold;
  font-size: 20px;
}
@media (max-width: 768px) {
  .why-section .step-features li {
    font-size: 17px;
    padding: 10px 0 10px 35px;
  }
}
.why-section .microcopy {
  margin-top: 50px;
  padding: 30px 40px;
  background: rgba(255, 255, 255, 0.15);
  border-left: 4px solid #ffffff;
  border-radius: 0 8px 8px 0;
  text-align: center;
}
.why-section .microcopy p {
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  color: #ffffff;
  margin: 0;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .why-section .microcopy p {
    font-size: 18px;
  }
}

.closing-section {
  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);
  color: #ffffff;
  padding: 96px 24px;
  text-align: center;
  position: relative;
  border-top: 1px solid rgba(226, 232, 240, 0.1);
}
.closing-section .container {
  max-width: 1024px;
  margin: 0 auto;
}
.closing-section .closing-content {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.closing-section .closing-statement {
  font-family: "Open Sans", sans-serif !important;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 32px;
  line-height: 1.3;
  letter-spacing: -0.5px;
  color: #ffffff !important;
}
@media (max-width: 768px) {
  .closing-section .closing-statement {
    font-size: 36px;
    margin-bottom: 40px;
  }
}
.closing-section .cta-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-bottom: 96px;
}
@media (min-width: 640px) {
  .closing-section .cta-buttons {
    flex-direction: row;
  }
}
.closing-section .btn-primary-cta {
  font-family: "Open Sans", sans-serif !important;
  padding: 20px 40px;
  font-size: 20px;
  font-weight: 700;
  border-radius: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #5ea1d8;
  color: #ffffff;
  box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.3);
  width: 100%;
}
.closing-section .btn-primary-cta:hover {
  transform: translateY(-4px);
}
@media (min-width: 640px) {
  .closing-section .btn-primary-cta {
    width: auto;
  }
}
.closing-section .btn-secondary-cta {
  font-family: "Open Sans", sans-serif !important;
  padding: 20px 40px;
  font-size: 20px;
  font-weight: 700;
  border-radius: 16px;
  border: 1px solid rgb(226, 232, 240);
  cursor: pointer;
  transition: all 0.3s ease;
  background: #ffffff;
  color: #212427;
  width: 100%;
}
.closing-section .btn-secondary-cta:hover {
  background: rgb(248, 250, 252);
}
@media (min-width: 640px) {
  .closing-section .btn-secondary-cta {
    width: auto;
  }
}
.closing-section .btn-primary,
.closing-section .btn-secondary {
  font-family: "Open Sans", sans-serif !important;
  padding: 18px 45px;
  font-size: 17px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  display: inline-block;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-transform: uppercase;
  min-width: 220px;
}
.closing-section .btn-primary {
  background: #ffffff;
  color: #5ea1d8;
  position: relative;
  overflow: hidden;
}
.closing-section .btn-primary::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(94, 161, 216, 0.1);
  transform: translate(-50%, -50%);
  transition: width 0.6s ease, height 0.6s ease;
}
.closing-section .btn-primary:hover {
  background: rgba(255, 255, 255, 0.95);
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.4);
}
.closing-section .btn-primary:hover::before {
  width: 300px;
  height: 300px;
}
.closing-section .btn-primary:active {
  transform: translateY(-1px);
}
.closing-section .btn-secondary {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  position: relative;
  overflow: hidden;
}
.closing-section .btn-secondary::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: left 0.4s ease;
}
.closing-section .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.9);
}
.closing-section .btn-secondary:hover::before {
  left: 0;
}
.closing-section .btn-secondary:active {
  transform: translateY(-1px);
}

.footer {
  background: #000000;
  color: #ffffff;
  padding: 14px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}
.footer .copy-rights {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}
.footer .copy-rights .row {
  display: flex;
  align-items: center;
  margin: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .copy-rights .row {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
.footer .copy-rights .col-md-5,
.footer .copy-rights .col-md-7,
.footer .copy-rights .col-12 {
  padding: 0;
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .footer .copy-rights .col-md-5,
  .footer .copy-rights .col-md-7,
  .footer .copy-rights .col-12 {
    width: 100%;
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-5 {
    justify-content: flex-start;
  }
}
@media (min-width: 769px) {
  .footer .copy-rights .col-md-7 {
    justify-content: flex-end;
  }
}
.footer .cpyrgt {
  color: #64748b !important;
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .cpyrgt {
    flex-wrap: wrap;
  }
}
.footer .cpyrgt li {
  color: #64748b !important;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.footer .cpyrgt li a {
  color: #64748b !important;
  text-decoration: none;
  margin-left: 4px;
}
.footer .cpyrgt li a:hover {
  color: #5ea1d8 !important;
  text-decoration: underline;
}
.footer .f-menu-right {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
}
@media (max-width: 768px) {
  .footer .f-menu-right {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
.footer .f-menu-right li {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
}
.footer .f-menu-right li:not(:last-child)::after {
  content: "|";
  color: rgba(100, 116, 139, 0.5);
  margin: 0 12px;
  font-size: 14px;
}
.footer .f-menu-right li a {
  color: #64748b !important;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 4px 0;
  white-space: nowrap;
}
.footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
.footer h6 {
  color: #94a3b8 !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  margin-bottom: 16px !important;
}
.footer ul li a {
  color: #64748b !important;
  font-size: 14px !important;
}
.footer ul li a:hover {
  color: #5ea1d8 !important;
}
.footer p {
  color: #475569 !important;
  font-size: 14px !important;
}
.footer .material-symbols-outlined {
  color: #475569 !important;
}
.footer .material-symbols-outlined:hover {
  color: #ffffff !important;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@media (max-width: 768px) {
  .container {
    padding: 0 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  .section {
    padding: 60px 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  .step-section,
  .audience-section,
  .why-section {
    padding: 60px 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  .sticky-nav .nav-links {
    justify-content: flex-start;
    padding: 12px 0;
    gap: 6px;
  }
  .sticky-nav .nav-link {
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    padding: 8px 14px;
    border-radius: 4px;
  }
  .btn-primary,
  .btn-secondary {
    min-width: auto;
    width: 100%;
    padding: 16px 30px;
    font-size: 16px;
  }
  .cta-buttons {
    flex-direction: column;
    gap: 12px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .section {
    padding: 70px 0;
  }
  .container {
    padding: 0 30px;
  }
}
@media screen and (max-width: 992px) {
  :host footer,
  :host .footer,
  app-how-it-works footer,
  app-how-it-works .footer {
    display: block !important;
    visibility: visible !important;
  }
}
body.theme-light .how-it-works-page {
  background: #f8fafc !important;
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .page-header {
  background: rgba(255, 255, 255, 0.95) !important;
  border-bottom-color: rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  -webkit-backdrop-filter: blur(20px) !important;
          backdrop-filter: blur(20px) !important;
}
body.theme-light .how-it-works-page .page-header.scrolled {
  background: rgba(255, 255, 255, 0.98) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}
body.theme-light .how-it-works-page .page-header .menu-button {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .page-header .menu-button:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}
body.theme-light .how-it-works-page .page-header .header-nav .nav-link {
  color: rgba(15, 23, 42, 0.5) !important;
}
body.theme-light .how-it-works-page .page-header .header-nav .nav-link:hover {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .page-header .btn-get-started {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}
body.theme-light .how-it-works-page .page-header .btn-get-started:hover {
  background: #4a8cc5 !important;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35) !important;
}
body.theme-light .how-it-works-page .hero-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .hero-section .hero-radial-gradient {
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 55%) !important;
}
body.theme-light .how-it-works-page .hero-section .hero-decorative-line {
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.4), transparent) !important;
}
body.theme-light .how-it-works-page .hero-section .hero-content {
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .hero-section .hero-title {
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .hero-section .hero-title .highlight-blue {
  color: rgba(255, 255, 255, 0.85) !important;
}
body.theme-light .how-it-works-page .hero-section .hero-description {
  color: rgba(255, 255, 255, 0.85) !important;
}
body.theme-light .how-it-works-page .hero-section .btn-primary-hero {
  background: #ffffff !important;
  color: #5ea1d8 !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
}
body.theme-light .how-it-works-page .hero-section .btn-primary-hero:hover {
  transform: scale(1.05);
}
body.theme-light .how-it-works-page .hero-section .btn-secondary-hero {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}
body.theme-light .how-it-works-page .hero-section .btn-secondary-hero:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}
body.theme-light .how-it-works-page .hero-section .btn-watch-demo {
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.55) !important;
}
body.theme-light .how-it-works-page .hero-section .btn-watch-demo:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}
body.theme-light .how-it-works-page .six-step-flow-section {
  background: #f8fafc !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .section-main-title {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .title-underline {
  background: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .steps-central-line {
  background: rgba(94, 161, 216, 0.2) !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-number {
  -webkit-text-stroke-color: rgba(58, 122, 181, 0.55) !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-title {
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-description {
  color: #475569 !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-list-normal li {
  color: #475569 !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-list-normal li::marker {
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-bullets li {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .six-step-flow-section .step-item .step-image-card {
  border-color: rgba(94, 161, 216, 0.2) !important;
  box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.08), 0 10px 10px -5px rgba(94, 161, 216, 0.04) !important;
}
body.theme-light .how-it-works-page .step-section {
  background: #ffffff !important;
}
body.theme-light .how-it-works-page .step-section:nth-child(even) {
  background: #f8fafc !important;
}
body.theme-light .how-it-works-page .step-section .step-number {
  -webkit-text-stroke-color: rgba(58, 122, 181, 0.55) !important;
}
body.theme-light .how-it-works-page .step-section .step-title {
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .step-section .step-description {
  color: #475569 !important;
}
body.theme-light .how-it-works-page .step-section .step-bullets li {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .step-section .step-image-card {
  border-color: rgba(94, 161, 216, 0.2) !important;
}
body.theme-light .how-it-works-page .step-section .body-copy {
  color: #334155 !important;
}
body.theme-light .how-it-works-page .step-section .step-features li {
  color: #334155 !important;
}
body.theme-light .how-it-works-page .step-section .microcopy {
  background: rgba(94, 161, 216, 0.07) !important;
  border-left-color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .step-section .microcopy p {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .stakeholders-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .stakeholders-section .section-main-title {
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .stakeholders-section .section-subtitle {
  color: rgba(255, 255, 255, 0.82) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card {
  background: rgba(255, 255, 255, 0.12) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card:hover {
  border-color: rgba(255, 255, 255, 0.45) !important;
  background: rgba(255, 255, 255, 0.18) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-icon-wrapper {
  background: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card:hover .stakeholder-icon-wrapper {
  background: rgba(255, 255, 255, 0.35) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-title {
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-description {
  color: rgba(255, 255, 255, 0.82) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn {
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}
body.theme-light .how-it-works-page .stakeholders-section .stakeholder-card .stakeholder-watch-btn:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.65) !important;
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .why-matters-section {
  background: #f8fafc !important;
}
body.theme-light .how-it-works-page .why-matters-section .section-main-title {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-matters-section .feature-description {
  color: #334155 !important;
}
body.theme-light .how-it-works-page .why-matters-section .why-card-description {
  color: #334155 !important;
}
body.theme-light .how-it-works-page .why-matters-section .why-matters-microcopy {
  color: #475569 !important;
}
body.theme-light .how-it-works-page .why-matters-section .why-card.sustainability-card, body.theme-light .how-it-works-page .why-matters-section .why-card.precision-card {
  background: rgba(94, 161, 216, 0.06) !important;
  border-color: rgba(94, 161, 216, 0.18) !important;
}
body.theme-light .how-it-works-page .why-matters-section .feature-header {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-matters-section .feature-header .feature-icon-small,
body.theme-light .how-it-works-page .why-matters-section .feature-header .feature-label {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-matters-section .why-card-title {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-matters-section .why-card-title .feature-icon-small,
body.theme-light .how-it-works-page .why-matters-section .why-card-title .feature-label {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-matters-section .stat-card {
  background: rgba(94, 161, 216, 0.06) !important;
  border-color: rgba(94, 161, 216, 0.15) !important;
}
body.theme-light .how-it-works-page .why-matters-section .stat-card .stat-label {
  color: #64748b !important;
}
body.theme-light .how-it-works-page .why-matters-section .precision-feature-item {
  background: rgba(94, 161, 216, 0.06) !important;
  border-color: rgba(94, 161, 216, 0.15) !important;
}
body.theme-light .how-it-works-page .why-matters-section .precision-feature-item .precision-text {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .why-section .body-copy {
  color: rgba(255, 255, 255, 0.95) !important;
}
body.theme-light .how-it-works-page .why-section .step-features li {
  color: rgba(255, 255, 255, 0.95) !important;
}
body.theme-light .how-it-works-page .closing-section {
  background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;
  border-top: none !important;
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .closing-section .closing-statement {
  color: #ffffff !important;
}
body.theme-light .how-it-works-page .closing-section .btn-primary-cta {
  background: #ffffff !important;
  color: #5ea1d8 !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15) !important;
}
body.theme-light .how-it-works-page .closing-section .btn-primary-cta:hover {
  transform: translateY(-4px);
}
body.theme-light .how-it-works-page .closing-section .btn-secondary-cta {
  background: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
}
body.theme-light .how-it-works-page .closing-section .btn-secondary-cta:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}
body.theme-light .how-it-works-page .closing-section .btn-primary {
  background: #ffffff !important;
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .closing-section .btn-primary:hover {
  background: rgba(255, 255, 255, 0.92) !important;
}
body.theme-light .how-it-works-page .closing-section .btn-secondary {
  background: rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
}
body.theme-light .how-it-works-page .closing-section .btn-secondary:hover {
  background: rgba(255, 255, 255, 0.22) !important;
}
body.theme-light .how-it-works-page .footer {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border-top-color: rgba(0, 0, 0, 0.08) !important;
}
body.theme-light .how-it-works-page .footer .cpyrgt li,
body.theme-light .how-it-works-page .footer .cpyrgt li a,
body.theme-light .how-it-works-page .footer .f-menu-right li a {
  color: #64748b !important;
}
body.theme-light .how-it-works-page .footer .cpyrgt li a:hover,
body.theme-light .how-it-works-page .footer .f-menu-right li a:hover {
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .footer .material-symbols-outlined {
  color: #94a3b8 !important;
}
body.theme-light .how-it-works-page .footer .material-symbols-outlined:hover {
  color: #5ea1d8 !important;
}
body.theme-light .how-it-works-page .section-heading {
  color: #0f172a !important;
}
body.theme-light .how-it-works-page .section-main-title {
  color: #0f172a !important;
}
body.theme-light .video-modal-card {
  background: #0f172a !important;
}

.video-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.video-modal-card {
  background: #0f172a;
  border-radius: 16px;
  max-width: 90vw;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease;
  border: 1px solid rgba(94, 161, 216, 0.2);
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (min-width: 768px) {
  .video-modal-card {
    max-width: 900px;
  }
}

.video-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.video-modal-header h4 {
  font-family: "Open Sans", sans-serif !important;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}
.video-modal-header .icon-button {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}
.video-modal-header .icon-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.video-modal-header .icon-button mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.video-modal-body {
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  overflow: hidden;
}
.video-modal-body .demo-video {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  background: #000000;
  outline: none;
}
@media (max-width: 768px) {
  .video-modal-body .demo-video {
    max-height: 60vh;
  }
}
.video-modal-body .demo-video.demo-video-iframe {
  aspect-ratio: 16/9;
  min-height: 320px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/how-it-works/how-it-works.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMhB;EACE,+CAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,0EAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AAJF;AAME;EACE,wBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAJJ;AAQE;EACE,mDAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,yBAAA;EACA,iCAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;EACA,6EAAA;EACA,8CAAA;EACA,6CAAA;AANJ;AAUE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,wBAAA;EACA,kDAAA;EACA,kCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,yBAAA;EACA,wCAAA;AARJ;AAWI;EACE,wBAAA;AATN;AAYI;EACE,yCAAA;EACA,kCAAA;AAVN;AAaI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAXN;AAaM;EAVF;IAWI,eAAA;IACA,SAAA;IACA,YAAA;EAVN;AACF;AAaI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAXN;AAcI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,cAAA;AAZN;AAcM;EACE,0CAAA;AAZR;AAeM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAbR;AAiBI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAfN;AAiBM;EACE,YAAA;EACA,WAAA;EACA,cAAA;AAfR;AAkBM;EACE;IACE,YAAA;EAhBR;AACF;AAoBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;AAlBN;AAoBM;EATF;IAUI,SAAA;EAjBN;AACF;AAmBM;EAbF;IAcI,aAAA;EAhBN;AACF;AAkBM;EACE,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAhBR;AAkBQ;EACE,cAAA;AAhBV;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAnBN;AAsBI;EACE,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AApBN;AAsBM;EAGE,YAAA;EACA,aAAA;EACA,gBAAA;AAtBR;AAyBM;EACE,uBAAA;AAvBR;AA2BI;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,sCAAA;AAzBN;AA4BI;EACE,mBAAA;AA1BN;AA6BI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,4EAAA;AA3BN;AA8BI;EACE,2BAAA;EACA,cAAA;EACA,mBAAA;AA5BN;AA+BI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7BN;AAgCI;EACE,yBAAA;AA9BN;AAiCI;EACE,yBAAA;AA/BN;AAkCI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;EACA,cAAA;AAhCN;AAkCM;EACE,qCAAA;EACA,2BAAA;EACA,yCAAA;AAhCR;AAmCM;EArBF;IAsBI,iBAAA;IACA,eAAA;EAhCN;AACF;AAqCE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAnCJ;AAqCI;EARF;IASI,eAAA;IACA,kBAAA;EAlCJ;AACF;AAsCE;EACE,eAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,0DAAA;EACA,+BAAA;AApCJ;AAsCI;EACE,UAAA;EACA,wBAAA;AApCN;AAyCE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0EAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAvCJ;AAyCI;EAhBF;IAiBI,uBAAA;IACA,gBAAA;EAtCJ;AACF;AAwCI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,2EAAA;AAtCN;AAyCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wFAAA;AAvCN;AA0CI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AAxCN;AA2CI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AAzCN;AA2CM;EACE,cAAA;AAzCR;AA4CM;EAlBF;IAmBI,eAAA;IACA,iBAAA;EAzCN;AACF;AA4CI;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;EACA,2CAAA;EACA,2BAAA;AA1CN;AA4CM;EAVF;IAWI,0BAAA;EAzCN;AACF;AA4CI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EACA,WAAA;AA1CN;AA4CM;EATF;IAUI,mBAAA;IACA,eAAA;IACA,uBAAA;EAzCN;AACF;AA4CI;EACE,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;EACA,+CAAA;EACA,WAAA;AA1CN;AA4CM;EACE,sBAAA;AA1CR;AA6CM;EAlBF;IAmBI,WAAA;EA1CN;AACF;AA6CI;EACE,mBAAA;EACA,cAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;EACA,WAAA;AA3CN;AA6CM;EACE,8BAAA;AA3CR;AA8CM;EAjBF;IAkBI,WAAA;EA3CN;AACF;AA+CI;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;AA7CN;AA+CM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7CR;AAgDM;EACE,mCAAA;EACA,sBAAA;AA9CR;AAiDM;EA5BF;IA6BI,WAAA;EA9CN;AACF;AAmDE;EACE,0EAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAjDJ;AAmDI;EATF;IAUI,kBAAA;IACA,kBAAA;EAhDJ;AACF;AAkDI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAhDN;AAmDI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAjDN;AAmDM;EARF;IASI,eAAA;EAhDN;AACF;AAmDI;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAjDN;AAoDI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAlDN;AAoDM;EAXF;IAYI,gBAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;EAjDN;AACF;AAmDM;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;AAjDR;AAmDQ;EAXF;IAYI,cAAA;EAhDR;AACF;AAmDM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAjDR;AAmDQ;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AAjDV;AAmDU;EAVF;IAWI,aAAA;IACA,mBAAA;IACA,SAAA;IACA,mBAAA;EAhDV;AACF;AAqDY;EACE;IACE,QAAA;EAnDd;EAqDY;IACE,QAAA;EAnDd;AACF;AA0DY;EACE;IACE,QAAA;EAxDd;EA0DY;IACE,QAAA;EAxDd;AACF;AA6DQ;EACE,OAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AA3DV;AA8DU;EAVF;IAWI,iBAAA;EA3DV;AACF;AA6DU;EAdF;IAeI,WAAA;IACA,eAAA;EA1DV;AACF;AA6DQ;EACE,OAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AA3DV;AA8DU;EARF;IASI,QAAA;IACA,WAAA;IACA,eAAA;EA3DV;AACF;AA6DU;EAdF;IAeI,WAAA;IACA,eAAA;IACA,YAAA;EA1DV;AACF;AA6DQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gDAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;AA3DV;AA8DU;EAbF;IAcI,QAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;EA3DV;AACF;AA8DQ;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AA5DV;AA+DU;EAbF;IAcI,QAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EA5DV;AACF;AA+DQ;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AA7DV;AAgEU;EAXF;IAYI,QAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EA7DV;EAgEU;IACE,QAAA;EA9DZ;AACF;AAkEQ;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhEV;AAkEU;EARF;IASI,QAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;EA/DV;AACF;AAiEU;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;AA/DZ;AAiEY;EACE,cAAA;AA/Dd;AAoEQ;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAlEV;AAqEU;EATF;IAUI,QAAA;IACA,WAAA;EAlEV;AACF;AAoEU;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAlEZ;AAoEY;EACE,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,gCAAA;EACA,6EAAA;AAlEd;AAuEQ;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qFAAA;EACA,+BAAA;EACA,uBAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;AArEV;AAuEU;EAdF;IAeI,WAAA;IACA,eAAA;IACA,SAAA;EApEV;AACF;AAuEY;EACE,qBAAA;AArEd;AAyEU;EACE,aAAA;AAvEZ;AA0EU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAxEZ;AAgFE;EACE,0EAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA9EJ;AAgFI;EACE,kBAAA;EACA,UAAA;AA9EN;AAiFI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AA/EN;AAiFM;EAPF;IAQI,mBAAA;IACA,SAAA;IACA,uBAAA;EA9EN;AACF;AAiFQ;EACE;IACE,QAAA;EA/EV;EAiFQ;IACE,QAAA;EA/EV;AACF;AAoFQ;EACE;IACE,QAAA;EAlFV;EAoFQ;IACE,QAAA;EAlFV;AACF;AAuFI;EACE,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AArFN;AAuFM;EAPF;IAQI,WAAA;EApFN;AACF;AAuFI;EACE,OAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;AArFN;AAuFM;EAPF;IAQI,WAAA;EApFN;AACF;AAuFI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gDAAA;EACA,kBAAA;EACA,oBAAA;AArFN;AAuFM;EAVF;IAWI,eAAA;EApFN;AACF;AAuFI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AArFN;AAuFM;EATF;IAUI,eAAA;EApFN;AACF;AAuFI;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AArFN;AAuFM;EAPF;IAQI,eAAA;EApFN;AACF;AAuFI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArFN;AAuFM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AArFR;AAuFQ;EACE,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,gCAAA;EACA,6EAAA;AArFV;AAwFQ;EApBF;IAqBI,eAAA;EArFR;AACF;AAyFI;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qFAAA;EACA,kBAAA;EACA,+BAAA;AAvFN;AA0FQ;EACE,qBAAA;AAxFV;AA4FM;EACE,aAAA;AA1FR;AA6FM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;AA3FR;AAiGE;EACE,0EAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA/FJ;AAiGI;EACE,kBAAA;EACA,UAAA;AA/FN;AAkGI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAhGN;AAkGM;EAVF;IAWI,eAAA;EA/FN;AACF;AAkGI;EACE,eAAA;EACI,kBAAA;EACJ,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhGN;AAkGM;EAbF;IAcI,eAAA;IACA,mBAAA;EA/FN;AACF;AAkGI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AAhGN;AAkGM;EAPF;IAQI,0BAAA;IACA,SAAA;EA/FN;AACF;AAkGI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,yCAAA;AAhGN;AAkGM;EACE,qCAAA;AAhGR;AAmGM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AAjGR;AAmGQ;EACE,0BAAA;AAjGV;AAqGM;EACE,mBAAA;EACA,cAAA;AAnGR;AAsGM;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AApGR;AAuGM;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,SAAA;AArGR;AAwGM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yCAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAtGR;AAwGQ;EACE,0BAAA;EACA,WAAA;EACA,YAAA;AAtGV;AAyGQ;EACE,oCAAA;EACA,qBAAA;EACA,cAAA;AAvGV;AA0GQ;EACE,0BAAA;EACA,mBAAA;AAxGV;AA+GE;EACE,0EAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA7GJ;AA+GI;EACE,iBAAA;EACA,cAAA;AA7GN;AAgHI;EAEE,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AA/GN;AAiHM;EAPF;IAQI,8BAAA;IACA,SAAA;EA9GN;AACF;AAiHI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA/GN;AAiHM;EACE,oCAAA;EACA,yCAAA;AA/GR;AAkHM;EACE,+CAAA;EACA,oDAAA;AAhHR;AAoHI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAlHN;AAoHM;EACE,mDAAA;EACA,0BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6EAAA;EACA,yBAAA;AAlHR;AAqHM;EACE,yBAAA;AAnHR;AAuHI;EACE,+CAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AArHN;AAuHM;EACE,mDAAA;EACA,0BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6EAAA;EACA,yBAAA;AArHR;AAwHM;EACE,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAtHR;AAyHM;EACE,gBAAA;EACA,eAAA;AAvHR;AA2HI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAzHN;AA4HI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AA1HN;AA4HM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA1HR;AA4HQ;EACE,0GAAA;AA1HV;AA+HI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,sBAAA;AA7HN;AA+HQ;EARJ;IASI,eAAA;EA5HN;AACF;AA+HI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7HN;AA+HM;EARF;IASI,eAAA;IACA,mBAAA;EA5HN;AACF;AA+HI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AA7HN;AAgII;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AA9HN;AAgIM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AA9HR;AAiIM;EACE,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,yBAAA;EACA,sBAAA;AA/HR;AAmII;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAjIN;AAmIM;EALF;IAMI,0BAAA;EAhIN;AACF;AAmII;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,0CAAA;AAjIN;AAmIM;EACE,mDAAA;EACA,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,6EAAA;AAjIR;AAoIM;EACE,gBAAA;EACA,yBAAA;AAlIR;AAsII;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,2BAAA;EACA,gBAAA;AApIN;AAyII;EACE,kBAAA;EACA,mBAAA;AAvIN;AA0II;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAxIN;AA0IM;EANF;IAOI,eAAA;EAvIN;AACF;AA0II;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;AAxIN;AA0IM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAxIR;AA2IM;EAxBF;IAyBI,eAAA;IACA,oBAAA;IACA,mBAAA;EAxIN;EA0IM;IACE,WAAA;IACA,WAAA;EAxIR;AACF;AA4II;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA1IN;AA4IM;EAPF;IAQI,eAAA;EAzIN;AACF;AA4II;EACE,gBAAA;EACA,cAAA;AA1IN;AA6II;EACE,mBAAA;AA3IN;AA8II;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA5IN;AA8IM;EATF;IAUI,eAAA;IACA,iBAAA;EA3IN;AACF;AA8II;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AA5IN;AA8IM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AA5IR;AA8IQ;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AA5IV;AA+IQ;EAhBF;IAiBI,eAAA;IACA,yBAAA;EA5IR;AACF;AAgJI;EACE,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;AA9IN;AAgJM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA9IR;AAgJQ;EARF;IASI,eAAA;EA7IR;AACF;;AAmJE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAhJJ;AAkJI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,2VACE;EAkBF,YAAA;EACA,oBAAA;EACA,UAAA;EACA,mDAAA;AAlKN;AAqKI;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAnKN;AAsKI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AApKN;AAsKM;EANF;IAOI,eAAA;EAnKN;AACF;AAsKI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;AApKN;AAsKM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EACA,kBAAA;AApKR;AAuKM;EAxBF;IAyBI,eAAA;IACA,oBAAA;IACA,mBAAA;EApKN;EAsKM;IACE,WAAA;IACA,WAAA;EApKR;AACF;AAwKI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;AAtKN;AAwKM;EAPF;IAQI,eAAA;EArKN;AACF;AAwKI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAtKN;AAyKI;EACE,mBAAA;AAvKN;AA0KI;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAxKN;AA0KM;EATF;IAUI,eAAA;IACA,iBAAA;EAvKN;AACF;AA0KI;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AAxKN;AA0KM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;AAxKR;AA0KQ;EACE,YAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAxKV;AA2KQ;EAhBF;IAiBI,eAAA;IACA,yBAAA;EAxKR;AACF;AA4KI;EACE,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;AA1KN;AA4KM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AA1KR;AA4KQ;EARF;IASI,eAAA;EAzKR;AACF;;AA+KE;EACE,0EAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8CAAA;AA5KJ;AA8KI;EACE,iBAAA;EACA,cAAA;AA5KN;AA+KI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA7KN;AAgLI;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA9KN;AAgLM;EATF;IAUI,eAAA;IACA,mBAAA;EA7KN;AACF;AAgLI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA9KN;AAgLM;EARF;IASI,mBAAA;EA7KN;AACF;AAgLI;EACE,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,oDAAA;EACA,WAAA;AA9KN;AAgLM;EACE,2BAAA;AA9KR;AAiLM;EAlBF;IAmBI,WAAA;EA9KN;AACF;AAiLI;EACE,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AA/KN;AAiLM;EACE,8BAAA;AA/KR;AAkLM;EAjBF;IAkBI,WAAA;EA/KN;AACF;AAoLI;;EAEE,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iDAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,0CAAA;EACA,yBAAA;EACA,gBAAA;AAlLN;AAqLI;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAnLN;AAqLM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EACA,6CAAA;AAnLR;AAsLM;EACE,qCAAA;EACA,2BAAA;EACA,+CAAA;AApLR;AAsLQ;EACE,YAAA;EACA,aAAA;AApLV;AAwLM;EACE,2BAAA;AAtLR;AA0LI;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxLN;AA0LM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;AAxLR;AA2LM;EACE,qCAAA;EACA,cAAA;EACA,2BAAA;EACA,+CAAA;EACA,sCAAA;AAzLR;AA2LQ;EACE,OAAA;AAzLV;AA6LM;EACE,2BAAA;AA3LR;;AAiME;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;AA9LJ;AAgMI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AA9LN;AAgMM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA9LR;AAgMQ;EANF;IAOI,sBAAA;IACA,uBAAA;IACA,SAAA;EA7LR;AACF;AAgMM;;;EAGE,UAAA;EACA,aAAA;EACA,mBAAA;AA9LR;AAgMQ;EAPF;;;IAQI,WAAA;IACA,2BAAA;EA3LR;AACF;AA+LQ;EADF;IAEI,2BAAA;EA5LR;AACF;AAgMQ;EADF;IAEI,yBAAA;EA7LR;AACF;AAiMI;EACE,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA/LN;AAiMM;EAXF;IAYI,eAAA;EA9LN;AACF;AAgMM;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA9LR;AAgMQ;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;AA9LV;AAgMU;EACE,yBAAA;EACA,0BAAA;AA9LZ;AAoMI;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;AAlMN;AAoMM;EAXF;IAYI,2BAAA;IACA,eAAA;EAjMN;AACF;AAmMM;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAjMR;AAmMQ;EACE,YAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;AAjMV;AAoMQ;EACE,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AAlMV;AAoMU;EACE,yBAAA;AAlMZ;AAwMI;EACE,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;AAtMN;AA2MQ;EACE,yBAAA;EACA,0BAAA;AAzMV;AA2MU;EACE,yBAAA;AAzMZ;AA+MI;EACE,yBAAA;EACA,0BAAA;AA7MN;AAgNI;EACE,yBAAA;AA9MN;AAgNM;EACE,yBAAA;AA9MR;;AAoNE;EACE;IACE,UAAA;IACA,2BAAA;EAjNJ;EAmNE;IACE,UAAA;IACA,wBAAA;EAjNJ;AACF;AAoNE;EACE;IACE,UAAA;IACA,qBAAA;EAlNJ;EAoNE;IACE,UAAA;IACA,mBAAA;EAlNJ;AACF;AAsNE;EACE;IACE,eAAA;IACA,WAAA;IACA,eAAA;IACA,sBAAA;IACA,kBAAA;EApNJ;EAuNE;IACE,eAAA;IACA,WAAA;IACA,eAAA;IACA,sBAAA;IACA,kBAAA;EArNJ;EAwNE;;;IAGE,eAAA;IACA,WAAA;IACA,eAAA;IACA,sBAAA;IACA,kBAAA;EAtNJ;EA0NI;IACE,2BAAA;IACA,eAAA;IACA,QAAA;EAxNN;EA2NI;IACE,oCAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAzNN;EA6NE;;IAEE,eAAA;IACA,WAAA;IACA,kBAAA;IACA,eAAA;EA3NJ;EA8NE;IACE,sBAAA;IACA,SAAA;EA5NJ;AACF;AAgOE;EACE;IACE,eAAA;EA9NJ;EAiOE;IACE,eAAA;EA/NJ;AACF;AAmOA;EACE;;;;IAIE,yBAAA;IACA,8BAAA;EAjOF;AACF;AAyOE;EACE,8BAAA;EACA,yBAAA;AAvOJ;AA0OI;EACE,gDAAA;EACA,mDAAA;EACA,oDAAA;EACA,8CAAA;UAAA,sCAAA;AAxON;AA0OM;EACE,gDAAA;EACA,oDAAA;AAxOR;AA2OM;EACE,yBAAA;AAzOR;AA0OQ;EAAU,gDAAA;AAvOlB;AA0OM;EACE,uCAAA;AAxOR;AAyOQ;EAAU,yBAAA;AAtOlB;AAyOM;EACE,8BAAA;EACA,yBAAA;EACA,2BAAA;AAvOR;AAwOQ;EACE,8BAAA;EACA,0DAAA;AAtOV;AA4OI;EACE,qFAAA;EACA,yBAAA;AA1ON;AA4OM;EACE,wGAAA;AA1OR;AA6OM;EACE,oGAAA;AA3OR;AA8OM;EAAgB,yBAAA;AA3OtB;AA6OM;EACE,yBAAA;AA3OR;AA4OQ;EAAkB,2CAAA;AAzO1B;AA4OM;EAAoB,2CAAA;AAzO1B;AA2OM;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAzOR;AA0OQ;EAAU,sBAAA;AAvOlB;AA0OM;EACE,gDAAA;EACA,yBAAA;EACA,iDAAA;AAxOR;AAyOQ;EAAU,gDAAA;AAtOlB;AAyOM;EACE,yBAAA;EACA,kDAAA;AAvOR;AAwOQ;EAAU,gDAAA;AArOlB;AA0OI;EACE,8BAAA;AAxON;AA0OM;EAAsB,yBAAA;AAvO5B;AAwOM;EAAsB,8BAAA;AArO5B;AAuOM;EAAsB,8CAAA;AApO5B;AAuOQ;EAAe,8DAAA;AApOvB;AAsOQ;EAAoB,yBAAA;AAnO5B;AAoOQ;EAAoB,yBAAA;AAjO5B;AAmOQ;EACE,yBAAA;AAjOV;AAkOU;EAAY,yBAAA;AA/NtB;AAkOQ;EAAmB,yBAAA;AA/N3B;AAiOQ;EACE,gDAAA;EACA,2GAAA;AA/NV;AAqOI;EACE,8BAAA;AAnON;AAqOM;EAAoB,8BAAA;AAlO1B;AAoOM;EAAe,8DAAA;AAjOrB;AAkOM;EAAoB,yBAAA;AA/N1B;AAgOM;EAAoB,yBAAA;AA7N1B;AA8NM;EAAoB,yBAAA;AA3N1B;AA6NM;EAAmB,gDAAA;AA1NzB;AA4NM;EAAoB,yBAAA;AAzN1B;AA0NM;EAAoB,yBAAA;AAvN1B;AAyNM;EACE,+CAAA;EACA,qCAAA;AAvNR;AAwNQ;EAAI,yBAAA;AArNZ;AA0NI;EACE,qFAAA;EACA,yBAAA;AAxNN;AA0NM;EAAsB,yBAAA;AAvN5B;AAwNM;EAAsB,2CAAA;AArN5B;AAuNM;EACE,gDAAA;EACA,iDAAA;AArNR;AAuNQ;EACE,kDAAA;EACA,gDAAA;AArNV;AAwNQ;EACE,+CAAA;EACA,yBAAA;AAtNV;AAyNQ;EACE,gDAAA;AAvNV;AA0NQ;EAA2B,yBAAA;AAvNnC;AAwNQ;EAA2B,2CAAA;AArNnC;AAuNQ;EACE,yBAAA;EACA,iDAAA;AArNV;AAsNU;EACE,gDAAA;EACA,kDAAA;EACA,yBAAA;AApNZ;AA2NI;EACE,8BAAA;AAzNN;AA2NM;EAAyB,yBAAA;AAxN/B;AAyNM;EAAyB,yBAAA;AAtN/B;AAuNM;EAAyB,yBAAA;AApN/B;AAqNM;EAAyB,yBAAA;AAlN/B;AAqNQ;EAEE,+CAAA;EACA,iDAAA;AApNV;AAwNM;EACE,yBAAA;AAtNR;AAuNQ;;EACiB,yBAAA;AApNzB;AAuNM;EACE,yBAAA;AArNR;AAsNQ;;EACiB,yBAAA;AAnNzB;AAsNM;EACE,+CAAA;EACA,iDAAA;AApNR;AAqNQ;EAAc,yBAAA;AAlNtB;AAqNM;EACE,+CAAA;EACA,iDAAA;AAnNR;AAoNQ;EAAkB,yBAAA;AAjN1B;AAuNM;EAAoB,2CAAA;AApN1B;AAqNM;EAAoB,2CAAA;AAlN1B;AAsNI;EACE,qFAAA;EACA,2BAAA;EACA,yBAAA;AApNN;AAsNM;EAAqB,yBAAA;AAnN3B;AAqNM;EACE,8BAAA;EACA,yBAAA;EACA,2DAAA;AAnNR;AAoNQ;EAAU,2BAAA;AAjNlB;AAoNM;EACE,gDAAA;EACA,yBAAA;EACA,iDAAA;AAlNR;AAmNQ;EAAU,gDAAA;AAhNlB;AAoNM;EACE,8BAAA;EACA,yBAAA;AAlNR;AAmNQ;EAAU,gDAAA;AAhNlB;AAmNM;EACE,gDAAA;EACA,yBAAA;EACA,kDAAA;AAjNR;AAkNQ;EAAU,gDAAA;AA/MlB;AAoNI;EACE,8BAAA;EACA,yBAAA;EACA,gDAAA;AAlNN;AAoNM;;;EAEqB,yBAAA;AAjN3B;AAmNM;;EAC2B,yBAAA;AAhNjC;AAkNM;EACE,yBAAA;AAhNR;AAiNQ;EAAU,yBAAA;AA9MlB;AAmNI;EAAsB,yBAAA;AAhN1B;AAiNI;EAAsB,yBAAA;AA9M1B;AAkNE;EACE,8BAAA;AAhNJ;;AAqNA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AAlNF;AAoNE;EACE;IACE,UAAA;EAlNJ;EAoNE;IACE,UAAA;EAlNJ;AACF;;AAsNA;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,4BAAA;EACA,yCAAA;AAnNF;AAqNE;EACE;IACE,UAAA;IACA,2BAAA;EAnNJ;EAqNE;IACE,UAAA;IACA,wBAAA;EAnNJ;AACF;AAsNE;EAvBF;IAwBI,gBAAA;EAnNF;AACF;;AAsNA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,iDAAA;AAnNF;AAqNE;EACE,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AAnNJ;AAsNE;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;AApNJ;AAsNI;EACE,0CAAA;AApNN;AAuNI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AArNN;;AA0NA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,gBAAA;AAvNF;AAyNE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAvNJ;AAyNI;EARF;IASI,gBAAA;EAtNJ;AACF;AAwNI;EACE,kBAAA;EACA,iBAAA;AAtNN","sourcesContent":["// How It Works Page Styles - Flowchest Brand Colors\n.how-it-works-wrapper {\n  // Wrapper has no overflow/transform so the fixed video modal is positioned relative to the viewport\n  // and stays visible in the current view without scrolling.\n}\n\n.how-it-works-page {\n  font-family: \"Open Sans\", sans-serif !important;\n  color: #ffffff;\n  line-height: 1.6;\n  overflow-x: hidden;\n  background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n  margin-top: 0 !important;\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n\n  .main-container {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n    overflow-x: hidden;\n  }\n\n  // Material Symbols Outlined Icons - Global Styles\n  .material-symbols-outlined {\n    font-family: 'Material Symbols Outlined' !important;\n    font-weight: normal !important;\n    font-style: normal !important;\n    font-size: 24px !important;\n    line-height: 1 !important;\n    letter-spacing: normal !important;\n    text-transform: none !important;\n    display: inline-block !important;\n    white-space: nowrap !important;\n    word-wrap: normal !important;\n    direction: ltr !important;\n    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n    -webkit-font-smoothing: antialiased !important;\n    -moz-osx-font-smoothing: grayscale !important;\n  }\n\n  // Page Header\n  .page-header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    width: 100%;\n    margin-top: 0 !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(10, 12, 16, 0.95);\n    backdrop-filter: blur(20px);\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n\n    // Ensure sidebar appears above page header when open\n    ~ :global(.flow-sidebar) {\n      z-index: 1001 !important;\n    }\n\n    &.scrolled {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n      background: rgba(10, 12, 16, 0.98);\n    }\n\n    .header-container {\n      max-width: 100%;\n      width: 100%;\n      padding: 0 16px;\n      height: 64px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n\n      @media (max-width: 768px) {\n        padding: 0 16px;\n        gap: 16px;\n        height: 56px;\n      }\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-shrink: 0;\n      margin-right: 0;\n    }\n\n    .menu-button {\n      background: none;\n      border: none;\n      color: #ffffff;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: background-color 0.2s;\n      flex-shrink: 0;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n      }\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n    }\n\n    .header-logo {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      img {\n        height: 45px;\n        width: auto;\n        display: block;\n      }\n\n      @media (max-width: 768px) {\n        img {\n          height: 35px;\n        }\n      }\n    }\n\n    .header-nav {\n      display: flex;\n      align-items: center;\n      gap: 40px;\n      flex: 1;\n      justify-content: center;\n      min-width: 0;\n      margin: 0 auto;\n\n      @media (max-width: 1024px) {\n        gap: 24px;\n      }\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .nav-link {\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 12px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.15em;\n        color: rgba(255, 255, 255, 0.5);\n        text-decoration: none;\n        transition: color 0.3s ease;\n        cursor: pointer;\n        white-space: nowrap;\n        padding: 4px 0;\n\n        &:hover {\n          color: #ffffff;\n        }\n      }\n    }\n\n    .header-actions {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin-left: auto;\n      flex-shrink: 0;\n    }\n\n    .theme-toggle-button {\n      border-radius: 999px;\n      padding: 2px;\n      background: transparent;\n      border: none;\n      outline: none;\n      box-shadow: none;\n      cursor: pointer;\n\n      &:focus,\n      &:active,\n      &:focus-visible {\n        border: none;\n        outline: none;\n        box-shadow: none;\n      }\n\n      &:hover {\n        background: transparent;\n      }\n    }\n\n    .theme-toggle-track {\n      width: 48px;\n      height: 26px;\n      border-radius: 999px;\n      background: #e5e7eb;\n      border: none;\n      display: inline-flex;\n      align-items: center;\n      padding: 1px;\n      transition: background-color 0.2s ease;\n    }\n\n    .theme-toggle-track.active {\n      background: #1f2937;\n    }\n\n    .theme-toggle-thumb {\n      width: 22px;\n      height: 22px;\n      border-radius: 50%;\n      background: #ffffff;\n      color: #6b7280;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      transform: translateX(0);\n      transition: transform 0.2s ease, color 0.2s ease, background-color 0.2s ease;\n    }\n\n    .theme-toggle-track.active .theme-toggle-thumb {\n      transform: translateX(22px);\n      color: #ffffff;\n      background: #0f172a;\n    }\n\n    .theme-toggle-thumb mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    .theme-toggle-track.active .theme-toggle-thumb mat-icon {\n      color: #ffffff !important;\n    }\n\n    .theme-toggle-track:not(.active) .theme-toggle-thumb mat-icon {\n      color: #6b7280 !important;\n    }\n\n    .btn-get-started {\n      background: #ffffff;\n      color: #000000;\n      padding: 10px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 700;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      white-space: nowrap;\n      flex-shrink: 0;\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      margin-left: 0;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.95);\n        transform: translateY(-1px);\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      @media (max-width: 768px) {\n        padding: 8px 16px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  // Container\n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 40px;\n    width: 100%;\n    box-sizing: border-box;\n    overflow-x: hidden;\n\n    @media (max-width: 768px) {\n      padding: 0 16px;\n      overflow-x: hidden;\n    }\n  }\n\n  // Section Base Styles with Scroll Animations\n  .section {\n    padding: 80px 0;\n    position: relative;\n    opacity: 0;\n    transform: translateY(30px);\n    transition: opacity 0.6s ease-out, transform 0.6s ease-out;\n    will-change: opacity, transform;\n\n    &.animate-in {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  // Hero Section\n  .hero-section {\n    min-height: 70vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    color: #ffffff;\n    text-align: center;\n    padding: 40px 24px 120px;\n    margin-top: 10px;\n    position: relative;\n    overflow: hidden;\n    opacity: 1;\n    transform: none;\n\n    @media (max-width: 768px) {\n      padding: 32px 24px 80px;\n      margin-top: 10px;\n    }\n\n    .hero-radial-gradient {\n      position: absolute;\n      inset: 0;\n      z-index: 0;\n      opacity: 0.2;\n      pointer-events: none;\n      background: radial-gradient(circle at 50% 50%, #5ea1d8 0%, transparent 50%);\n    }\n\n    .hero-decorative-line {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      height: 1px;\n      background: linear-gradient(to right, transparent, rgba(94, 161, 216, 0.5), transparent);\n    }\n\n    .hero-content {\n      max-width: 1024px;\n      padding: 0 24px;\n      position: relative;\n      z-index: 2;\n      background: transparent;\n      color: #ffffff;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 32px;\n      width: 100%;\n      margin-top: 0;\n    }\n\n    .hero-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 48px;\n      font-weight: 900;\n      line-height: 1.2;\n      margin: 0 auto 24px;\n      letter-spacing: -0.02em;\n      color: #ffffff;\n      animation: fadeInUp 0.8s ease-out;\n      max-width: 672px;\n      width: 100%;\n      white-space: normal;\n      word-wrap: break-word;\n\n      .highlight-blue {\n        color: #5ea1d8;\n      }\n\n      @media (min-width: 768px) {\n        font-size: 72px;\n        line-height: 1.15;\n      }\n    }\n\n    .hero-description {\n      font-size: 18px !important;\n      line-height: 1.8 !important;\n      margin: 0 auto !important;\n      color: rgba(148, 163, 184, 1) !important;\n      max-width: 672px;\n      width: 100%;\n      animation: fadeInUp 0.8s ease-out 0.2s both;\n      font-weight: 400 !important;\n\n      @media (min-width: 768px) {\n        font-size: 20px !important;\n      }\n    }\n\n    .hero-cta-buttons {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      justify-content: center;\n      align-items: center;\n      animation: fadeInUp 0.8s ease-out 0.4s both;\n      width: 100%;\n\n      @media (min-width: 640px) {\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n      }\n    }\n\n    .btn-primary-hero {\n      background: #5ea1d8;\n      color: #ffffff;\n      border: none;\n      padding: 16px 32px;\n      font-size: 18px;\n      font-weight: 700;\n      border-radius: 12px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      font-family: \"Open Sans\", sans-serif !important;\n      box-shadow: 0 10px 25px rgba(94, 161, 216, 0.2);\n      width: 100%;\n\n      &:hover {\n        transform: scale(1.05);\n      }\n\n      @media (min-width: 640px) {\n        width: auto;\n      }\n    }\n\n    .btn-secondary-hero {\n      background: #ffffff;\n      color: #212427;\n      border: 1px solid rgba(226, 232, 240, 1);\n      padding: 16px 32px;\n      font-size: 18px;\n      font-weight: 700;\n      border-radius: 12px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      font-family: \"Open Sans\", sans-serif !important;\n      width: 100%;\n\n      &:hover {\n        background: rgba(248, 250, 252, 1);\n      }\n\n      @media (min-width: 640px) {\n        width: auto;\n      }\n\n    }\n\n    .btn-watch-demo {\n      background: transparent;\n      color: #5ea1d8;\n      border: 2px solid #5ea1d8;\n      padding: 16px 32px;\n      font-size: 18px;\n      font-weight: 700;\n      border-radius: 12px;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      font-family: \"Open Sans\", sans-serif !important;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      justify-content: center;\n      width: 100%;\n\n      mat-icon {\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n\n      &:hover {\n        background: rgba(94, 161, 216, 0.1);\n        transform: scale(1.05);\n      }\n\n      @media (min-width: 640px) {\n        width: auto;\n      }\n    }\n  }\n\n  // The 6-Step Flow Section Title\n  .six-step-flow-section {\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    padding: 96px 24px;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    box-sizing: border-box;\n\n    @media (max-width: 768px) {\n      padding: 60px 16px;\n      overflow-x: hidden;\n    }\n\n    .container {\n      position: relative;\n      z-index: 1;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      overflow-x: hidden;\n    }\n\n    .section-main-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 48px;\n      font-weight: 700;\n      color: #ffffff !important;\n      margin: 0 0 16px 0;\n      letter-spacing: -0.5px;\n\n      @media (max-width: 768px) {\n        font-size: 36px;\n      }\n    }\n\n    .title-underline {\n      width: 96px;\n      height: 6px;\n      background: #5ea1d8;\n      margin: 0 auto;\n      border-radius: 9999px;\n    }\n\n    .steps-vertical-container {\n      position: relative;\n      margin-top: 80px;\n      display: flex;\n      flex-direction: column;\n      gap: 128px;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      overflow-x: hidden;\n\n      @media (max-width: 768px) {\n        margin-top: 40px;\n        gap: 64px;\n        width: 100%;\n        max-width: 100%;\n      }\n\n      .steps-central-line {\n        position: absolute;\n        left: 50%;\n        top: 0;\n        bottom: 0;\n        width: 1px;\n        background: rgba(226, 232, 240, 1);\n        transform: translateX(-50%);\n        z-index: 0;\n        display: none;\n\n        @media (min-width: 1024px) {\n          display: block;\n        }\n      }\n\n      .step-item {\n        position: relative;\n        z-index: 1;\n        width: 100%;\n        max-width: 100%;\n        box-sizing: border-box;\n        overflow-x: hidden;\n\n        .step-content-wrapper {\n          display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 24px;\n          width: 100%;\n          max-width: 100%;\n          box-sizing: border-box;\n          overflow-x: hidden;\n\n          @media (min-width: 1024px) {\n            display: flex;\n            flex-direction: row;\n            gap: 96px;\n            align-items: center;\n          }\n        }\n\n        &.step-item-left {\n          .step-content-wrapper {\n            @media (min-width: 1024px) {\n              .step-content-text {\n                order: 1;\n              }\n              .step-content-image {\n                order: 2;\n              }\n            }\n          }\n        }\n\n        &.step-item-right {\n          .step-content-wrapper {\n            @media (min-width: 1024px) {\n              .step-content-text {\n                order: 2;\n              }\n              .step-content-image {\n                order: 1;\n              }\n            }\n          }\n        }\n\n        .step-content-text {\n          flex: 1;\n          width: 100%;\n          max-width: 100%;\n          text-align: left;\n          align-self: flex-start;\n          box-sizing: border-box;\n          overflow-x: hidden;\n\n          // Mobile: Use display: contents so children can be reordered at wrapper level\n          @media (max-width: 1023px) {\n            display: contents;\n          }\n\n          @media (min-width: 1024px) {\n            width: auto;\n            max-width: none;\n          }\n        }\n\n        .step-content-image {\n          flex: 1;\n          width: 100%;\n          max-width: 100%;\n          box-sizing: border-box;\n          overflow: hidden;\n\n          // Mobile: Show image after step number\n          @media (max-width: 1023px) {\n            order: 2;\n            width: 100%;\n            max-width: 100%;\n          }\n\n          @media (min-width: 1024px) {\n            width: auto;\n            max-width: none;\n            order: unset;\n          }\n        }\n\n        .step-number {\n          font-size: 72px;\n          font-weight: 900;\n          line-height: 1;\n          margin-bottom: 16px;\n          display: block;\n          -webkit-text-stroke: 1px rgba(94, 161, 216, 0.3);\n          color: transparent;\n          letter-spacing: -2px;\n          max-width: 100%;\n          box-sizing: border-box;\n\n          // Mobile: Show step number first and adjust size\n          @media (max-width: 1023px) {\n            order: 1;\n            width: 100%;\n            max-width: 100%;\n            font-size: 48px;\n            margin-bottom: 24px;\n          }\n        }\n\n        .step-title {\n          font-family: \"Open Sans\", sans-serif !important;\n          font-size: 30px;\n          font-weight: 700;\n          line-height: 1.2;\n          margin-bottom: 16px;\n          color: #5ea1d8 !important;\n          letter-spacing: -0.3px;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          max-width: 100%;\n\n          // Mobile: Show title after image\n          @media (max-width: 1023px) {\n            order: 3;\n            width: 100%;\n            max-width: 100%;\n            font-size: 24px;\n          }\n        }\n\n        .step-description {\n          font-size: 18px;\n          line-height: 1.7;\n          color: rgba(148, 163, 184, 1) !important;\n          margin-bottom: 24px;\n          font-weight: 400;\n          word-wrap: break-word;\n          overflow-wrap: break-word;\n          max-width: 100%;\n\n          // Mobile: Show description after image\n          @media (max-width: 1023px) {\n            order: 4;\n            width: 100%;\n            max-width: 100%;\n            font-size: 16px;\n\n            // If there's a second description after list, it should come after bullets\n            &:nth-of-type(2) {\n              order: 6;\n            }\n          }\n        }\n\n        .step-list-normal {\n          list-style: disc;\n          padding-left: 24px;\n          margin: 16px 0;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n\n          @media (max-width: 1023px) {\n            order: 5;\n            width: 100%;\n            margin-top: 0;\n            margin-bottom: 16px;\n          }\n\n          li {\n            font-size: 14px;\n            line-height: 1.7;\n            color: rgba(148, 163, 184, 1) !important;\n            font-weight: 400;\n\n            &::marker {\n              color: #ffffff;\n            }\n          }\n        }\n\n        .step-bullets {\n          list-style: none;\n          padding: 0;\n          margin: 0;\n          display: flex;\n          flex-direction: column;\n          gap: 12px;\n\n          // Mobile: Show bullets after image\n          @media (max-width: 1023px) {\n            order: 7;\n            width: 100%;\n          }\n\n          li {\n            font-size: 18px;\n            line-height: 1.5;\n            color: #ffffff !important;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-weight: 400;\n\n            .check-icon {\n              font-family: 'Material Symbols Outlined' !important;\n              font-size: 16px !important;\n              color: #5ea1d8 !important;\n              font-weight: normal !important;\n              font-style: normal !important;\n              line-height: 1 !important;\n              display: inline-block !important;\n              font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n            }\n          }\n        }\n\n        .step-image-card {\n          width: 100%;\n          max-width: 100%;\n          aspect-ratio: 16 / 9;\n          border-radius: 16px;\n          overflow: hidden;\n          position: relative;\n          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n          transition: transform 0.7s ease;\n          background: transparent;\n          border: 1px solid rgba(226, 232, 240, 1);\n          cursor: pointer;\n          box-sizing: border-box;\n\n          @media (max-width: 768px) {\n            width: 100%;\n            max-width: 100%;\n            margin: 0;\n          }\n\n          &:hover {\n            .step-image-img {\n              transform: scale(1.1);\n            }\n          }\n\n          .image-overlay {\n            display: none;\n          }\n\n          .step-image-img {\n            width: 100%;\n            max-width: 100%;\n            height: 100%;\n            object-fit: cover;\n            mix-blend-mode: normal;\n            transition: transform 0.7s ease;\n            position: relative;\n            z-index: 1;\n            display: block;\n          }\n        }\n      }\n    }\n  }\n\n  // Step Sections\n  .step-section {\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    padding: 80px 0;\n    position: relative;\n    overflow: hidden;\n\n    .container {\n      position: relative;\n      z-index: 1;\n    }\n\n    .step-wrapper {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 48px;\n      position: relative;\n\n      @media (min-width: 1024px) {\n        flex-direction: row;\n        gap: 96px;\n        align-items: flex-start;\n      }\n\n      &.step-left {\n        @media (min-width: 1024px) {\n          .step-content-left {\n            order: 1;\n          }\n          .step-content-right {\n            order: 2;\n          }\n        }\n      }\n\n      &.step-right {\n        @media (min-width: 1024px) {\n          .step-content-left {\n            order: 2;\n          }\n          .step-content-right {\n            order: 1;\n          }\n        }\n      }\n    }\n\n    .step-content-left {\n      flex: 1;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n\n      @media (min-width: 1024px) {\n        width: auto;\n      }\n    }\n\n    .step-content-right {\n      flex: 1;\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n      align-items: flex-start;\n\n      @media (min-width: 1024px) {\n        width: auto;\n      }\n    }\n\n    .step-number {\n      font-size: 72px;\n      font-weight: 900;\n      line-height: 1;\n      margin-bottom: 16px;\n      display: block;\n      -webkit-text-stroke: 1px rgba(94, 161, 216, 0.3);\n      color: transparent;\n      letter-spacing: -2px;\n\n      @media (max-width: 768px) {\n        font-size: 56px;\n      }\n    }\n\n    .step-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 30px;\n      font-weight: 700;\n      line-height: 1.2;\n      margin-bottom: 16px;\n      color: #5ea1d8;\n      letter-spacing: -0.3px;\n\n      @media (max-width: 768px) {\n        font-size: 30px;\n      }\n    }\n\n    .step-description {\n      font-size: 18px;\n      line-height: 1.7;\n      color: rgba(148, 163, 184, 1) !important;\n      margin-bottom: 24px;\n      font-weight: 400;\n\n      @media (max-width: 768px) {\n        font-size: 18px;\n      }\n    }\n\n    .step-bullets {\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n\n      li {\n        font-size: 18px;\n        line-height: 1.5;\n        color: #ffffff !important;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 400;\n\n        .check-icon {\n          font-family: 'Material Symbols Outlined' !important;\n          font-size: 20px !important;\n          color: #5ea1d8 !important;\n          font-weight: normal !important;\n          font-style: normal !important;\n          line-height: 1 !important;\n          display: inline-block !important;\n          font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n        }\n\n        @media (max-width: 768px) {\n          font-size: 16px;\n        }\n      }\n    }\n\n    .step-image-card {\n      width: 100%;\n      aspect-ratio: 16 / 9;\n      background: transparent;\n      border-radius: 16px;\n      overflow: hidden;\n      border: 1px solid #e2e8f0;\n      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      position: relative;\n      transition: transform 0.7s ease;\n\n      &:hover {\n        .step-image-img {\n          transform: scale(1.1);\n        }\n      }\n\n      .image-overlay {\n        display: none;\n      }\n\n      .step-image-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        mix-blend-mode: normal;\n        transition: transform 0.7s ease;\n        position: relative;\n        z-index: 1;\n      }\n    }\n  }\n\n  // Stakeholders Section\n  .stakeholders-section {\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    padding: 96px 24px;\n    position: relative;\n    color: #ffffff !important;\n    overflow: hidden;\n\n    .container {\n      position: relative;\n      z-index: 1;\n    }\n\n    .section-main-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 30px;\n      font-weight: 700;\n      color: #ffffff !important;\n      margin-bottom: 0;\n      margin-top: 0;\n      text-align: center;\n      letter-spacing: -0.5px;\n\n      @media (min-width: 768px) {\n        font-size: 36px;\n      }\n    }\n\n    .section-subtitle {\n      font-size: 18px;\n          display: ruby-text;\n      color: rgba(148, 163, 184, 1) !important;\n      text-align: center;\n      margin-top: 4px;\n      margin-bottom: 64px;\n      max-width: 672px;\n      margin-left: auto;\n      margin-right: auto;\n      line-height: 1.7;\n      padding-top: 0;\n\n      @media (max-width: 768px) {\n        font-size: 16px;\n        margin-bottom: 40px;\n      }\n    }\n\n    .stakeholder-cards {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 30px;\n      max-width: 1200px;\n      margin: 0 auto;\n\n      @media (max-width: 968px) {\n        grid-template-columns: 1fr;\n        gap: 24px;\n      }\n    }\n\n    .stakeholder-card {\n      background: #101922;\n      padding: 32px;\n      border-radius: 16px;\n      text-align: left;\n      transition: all 0.3s ease;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        border-color: rgba(94, 161, 216, 0.5);\n      }\n\n      .stakeholder-icon-wrapper {\n        width: 48px;\n        height: 48px;\n        margin-bottom: 24px;\n        background: rgba(94, 161, 216, 0.1);\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #5ea1d8;\n        transition: all 0.3s ease;\n\n        .material-symbols-outlined {\n          font-size: 24px !important;\n        }\n      }\n\n      &:hover .stakeholder-icon-wrapper {\n        background: #5ea1d8;\n        color: #ffffff;\n      }\n\n      .stakeholder-title {\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 20px;\n        font-weight: 700;\n        color: #ffffff !important;\n        margin-bottom: 12px;\n      }\n\n      .stakeholder-description {\n        font-size: 16px;\n        line-height: 1.6;\n        color: rgba(148, 163, 184, 1) !important;\n        margin: 0;\n      }\n\n      .stakeholder-watch-btn {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        margin-top: 20px;\n        padding: 8px 16px;\n        font-family: \"Open Sans\", sans-serif !important;\n        font-size: 14px;\n        font-weight: 600;\n        color: #5ea1d8;\n        background: transparent;\n        border: 1px solid rgba(94, 161, 216, 0.5);\n        border-radius: 10px;\n        cursor: pointer;\n        transition: all 0.25s ease;\n\n        .material-symbols-outlined {\n          font-size: 20px !important;\n          width: 20px;\n          height: 20px;\n        }\n\n        &:hover {\n          background: rgba(94, 161, 216, 0.12);\n          border-color: #5ea1d8;\n          color: #7eb8e8;\n        }\n\n        &:focus-visible {\n          outline: 2px solid #5ea1d8;\n          outline-offset: 2px;\n        }\n      }\n    }\n  }\n\n  // Why Matters Section (Sustainability & Precision)\n  .why-matters-section {\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    padding: 96px 24px;\n    position: relative;\n    overflow: hidden;\n\n    .container {\n      max-width: 1280px;\n      margin: 0 auto;\n    }\n\n    .why-matters-grid {\n      // display: grid;\n      grid-template-columns: 1fr;\n      gap: 48px;\n      position: relative;\n      z-index: 1;\n\n      @media (min-width: 1024px) {\n        grid-template-columns: 1fr 1fr;\n        gap: 48px;\n      }\n    }\n\n    .why-card {\n      padding: 40px;\n      border-radius: 24px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n\n      &.sustainability-card {\n        background: rgba(94, 161, 216, 0.05);\n        border: 1px solid rgba(94, 161, 216, 0.2);\n      }\n\n      &.precision-card {\n        background: rgba(94, 161, 216, 0.05) !important;\n        border: 1px solid rgba(94, 161, 216, 0.2) !important;\n      }\n    }\n\n    .feature-header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: #ffffff !important;\n      font-weight: 700;\n      margin-bottom: 0;\n      text-transform: uppercase;\n      letter-spacing: 0.1em;\n      font-size: 12px;\n\n      .feature-icon-small {\n        font-family: 'Material Symbols Outlined' !important;\n        font-size: 14px !important;\n        font-weight: normal !important;\n        font-style: normal !important;\n        font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n        color: #ffffff !important;\n      }\n\n      .feature-label {\n        color: #ffffff !important;\n      }\n    }\n\n    .why-card-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: revert !important;\n      font-weight: 700;\n      color: #ffffff !important;\n      margin-bottom: 24px;\n      letter-spacing: -0.5px;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n\n      .feature-icon-small {\n        font-family: 'Material Symbols Outlined' !important;\n        font-size: 14px !important;\n        font-weight: normal !important;\n        font-style: normal !important;\n        font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n        color: #ffffff !important;\n      }\n\n      .feature-label {\n        color: #ffffff !important;\n        text-transform: uppercase;\n        letter-spacing: 0.1em;\n        font-size: 12px;\n        font-weight: 700;\n      }\n\n      > span:last-child {\n        flex-basis: 100%;\n        margin-top: 8px;\n      }\n    }\n\n    .why-card-description {\n      font-size: 18px;\n      line-height: 1.7;\n      color: #ffffff !important;\n      margin-bottom: 32px;\n    }\n\n    .feature-header {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 16px;\n      margin-bottom: 24px;\n\n      .feature-icon {\n        width: 32px;\n        height: 32px;\n        background: #5ea1d8;\n        border-radius: 4px;\n\n        &.leaf-icon {\n          clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);\n        }\n      }\n    }\n\n    .section-main-title {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 42px;\n      font-weight: 700;\n      color: #ffffff !important;\n      margin: 0;\n      letter-spacing: -0.5px;\n\n        @media (max-width: 768px) {\n        font-size: 32px;\n      }\n    }\n\n    .feature-description {\n      font-size: 18px;\n      line-height: 1.7;\n      color: #ffffff !important;\n      text-align: center;\n      max-width: 900px;\n      margin: 0 auto 50px;\n\n      @media (max-width: 768px) {\n        font-size: 16px;\n        margin-bottom: 40px;\n      }\n    }\n\n    .feature-stats {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 16px;\n    }\n\n    .stat-card {\n      background: rgba(255, 255, 255, 0.1);\n      padding: 16px;\n      border-radius: 12px;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n\n      .stat-value {\n        font-size: 24px;\n        font-weight: 700;\n        color: #5ea1d8 !important;\n        margin-bottom: 4px;\n        line-height: 1;\n      }\n\n      .stat-label {\n        font-size: 12px;\n        font-weight: 500;\n        color: rgba(255, 255, 255, 0.6) !important;\n        text-transform: uppercase;\n        letter-spacing: 0.05em;\n      }\n    }\n\n    .precision-features {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 16px;\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .precision-feature-item {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      padding: 16px;\n      background: rgba(255, 255, 255, 0.1);\n      border-radius: 12px;\n      border: 1px solid rgba(255, 255, 255, 0.1);\n\n      .precision-icon {\n        font-family: 'Material Symbols Outlined' !important;\n        font-size: 24px !important;\n        color: #5ea1d8 !important;\n        font-weight: normal !important;\n        font-style: normal !important;\n        font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24 !important;\n      }\n\n      .precision-text {\n        font-weight: 500;\n        color: #ffffff !important;\n      }\n    }\n\n    .why-matters-microcopy {\n      text-align: center;\n      font-size: 18px;\n      line-height: 1.7;\n      color: rgba(148, 163, 184, 1) !important;\n      margin-top: 48px !important;\n      font-weight: 400;\n    }\n  }\n\n\n    .step-header {\n      text-align: center;\n      margin-bottom: 50px;\n    }\n\n    .step-number-large {\n      font-size: 80px;\n      line-height: 1;\n      margin-bottom: 20px;\n      display: inline-block;\n\n      @media (max-width: 768px) {\n        font-size: 60px;\n      }\n    }\n\n    .section-heading {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 42px;\n      font-weight: 700;\n      line-height: 1.2;\n      margin-bottom: 16px;\n      text-align: center;\n      color: #ffffff !important;\n      letter-spacing: -0.5px;\n      position: relative;\n      padding-bottom: 20px;\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 60px;\n        height: 3px;\n        background: #5ea1d8;\n        border-radius: 2px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 32px;\n        padding-bottom: 15px;\n        margin-bottom: 20px;\n\n        &::after {\n          width: 40px;\n          height: 2px;\n        }\n      }\n    }\n\n    .step-subtitle {\n      font-size: 24px;\n      font-weight: 400;\n      color: #5ea1d8;\n      margin-bottom: 40px;\n      font-style: italic;\n\n      @media (max-width: 768px) {\n        font-size: 20px;\n      }\n    }\n\n    .step-content {\n      max-width: 900px;\n      margin: 0 auto;\n    }\n\n    .step-description {\n      margin-bottom: 40px;\n    }\n\n    .body-copy {\n      font-size: 18px;\n      line-height: 1.8;\n      color: #ffffff !important;\n      margin-bottom: 24px;\n      text-align: left;\n      font-weight: 400;\n      max-width: 100%;\n\n      @media (max-width: 768px) {\n        font-size: 17px;\n        line-height: 1.75;\n      }\n    }\n\n    .step-features {\n      list-style: none;\n      padding: 0;\n      margin: 24px 0;\n      text-align: left;\n\n      li {\n        font-size: 18px;\n        line-height: 1.8;\n        color: #ffffff !important;\n        padding: 12px 0 12px 40px;\n        position: relative;\n\n        &::before {\n          content: '✓';\n          position: absolute;\n          left: 0;\n          color: #5ea1d8 !important;\n          font-weight: bold;\n          font-size: 20px;\n        }\n\n        @media (max-width: 768px) {\n          font-size: 17px;\n          padding: 10px 0 10px 35px;\n        }\n      }\n    }\n\n    .microcopy {\n      margin-top: 50px;\n      padding: 30px 40px;\n      background: rgba(94, 161, 216, 0.08);\n      border-left: 4px solid #5ea1d8;\n      border-radius: 0 8px 8px 0;\n      text-align: center;\n\n      p {\n        font-size: 20px;\n        font-weight: 600;\n        font-style: italic;\n        color: #ffffff !important;\n        margin: 0;\n        line-height: 1.6;\n\n        @media (max-width: 768px) {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n\n  // Why Section\n  .why-section {\n    background: #5ea1d8;\n    padding: 100px 0;\n    position: relative;\n    color: #ffffff;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 50%;\n      height: 100%;\n      background-image: \n        repeating-linear-gradient(\n          60deg,\n          transparent,\n          transparent 20px,\n          rgba(255, 255, 255, 0.15) 20px,\n          rgba(255, 255, 255, 0.15) 21px,\n          transparent 21px,\n          transparent 40px\n        ),\n        repeating-linear-gradient(\n          -60deg,\n          transparent,\n          transparent 25px,\n          rgba(255, 255, 255, 0.12) 25px,\n          rgba(255, 255, 255, 0.12) 26px,\n          transparent 26px,\n          transparent 50px\n        );\n      opacity: 0.6;\n      pointer-events: none;\n      z-index: 0;\n      clip-path: polygon(0 0, 100% 0, 42.3% 100%, 0 100%);\n    }\n\n    .step-header {\n      text-align: center;\n      margin-bottom: 50px;\n      position: relative;\n      z-index: 1;\n    }\n\n    .step-number-large {\n      font-size: 80px;\n      line-height: 1;\n      margin-bottom: 20px;\n      display: inline-block;\n\n      @media (max-width: 768px) {\n        font-size: 60px;\n      }\n    }\n\n    .section-heading {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 42px;\n      font-weight: 700;\n      line-height: 1.2;\n      margin-bottom: 16px;\n      text-align: center;\n      color: #ffffff;\n      letter-spacing: -0.5px;\n      position: relative;\n      padding-bottom: 20px;\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 60px;\n        height: 3px;\n        background: rgba(255, 255, 255, 0.5);\n        border-radius: 2px;\n      }\n\n      @media (max-width: 768px) {\n        font-size: 32px;\n        padding-bottom: 15px;\n        margin-bottom: 20px;\n\n        &::after {\n          width: 40px;\n          height: 2px;\n        }\n      }\n    }\n\n    .step-subtitle {\n      font-size: 24px;\n      font-weight: 400;\n      color: rgba(255, 255, 255, 0.9);\n      margin-bottom: 40px;\n      font-style: italic;\n\n      @media (max-width: 768px) {\n        font-size: 20px;\n      }\n    }\n\n    .step-content {\n      max-width: 900px;\n      margin: 0 auto;\n      position: relative;\n      z-index: 1;\n    }\n\n    .step-description {\n      margin-bottom: 40px;\n    }\n\n    .body-copy {\n      font-size: 18px;\n      line-height: 1.8;\n      color: rgba(255, 255, 255, 0.95);\n      margin-bottom: 24px;\n      text-align: left;\n      font-weight: 400;\n      max-width: 100%;\n\n      @media (max-width: 768px) {\n        font-size: 17px;\n        line-height: 1.75;\n      }\n    }\n\n    .step-features {\n      list-style: none;\n      padding: 0;\n      margin: 24px 0;\n      text-align: left;\n\n      li {\n        font-size: 18px;\n        line-height: 1.8;\n        color: rgba(255, 255, 255, 0.95);\n        padding: 12px 0 12px 40px;\n        position: relative;\n\n        &::before {\n          content: '✓';\n          position: absolute;\n          left: 0;\n          color: #ffffff;\n          font-weight: bold;\n          font-size: 20px;\n        }\n\n        @media (max-width: 768px) {\n          font-size: 17px;\n          padding: 10px 0 10px 35px;\n        }\n      }\n    }\n\n    .microcopy {\n      margin-top: 50px;\n      padding: 30px 40px;\n      background: rgba(255, 255, 255, 0.15);\n      border-left: 4px solid #ffffff;\n      border-radius: 0 8px 8px 0;\n      text-align: center;\n\n      p {\n        font-size: 20px;\n        font-weight: 600;\n        font-style: italic;\n        color: #ffffff;\n        margin: 0;\n        line-height: 1.6;\n\n        @media (max-width: 768px) {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n\n  // Closing Section\n  .closing-section {\n    background: linear-gradient(135deg, #0f172a 0%, #1a1f2e 50%, #101922 100%);\n    color: #ffffff;\n    padding: 96px 24px;\n    text-align: center;\n    position: relative;\n    border-top: 1px solid rgba(226, 232, 240, 0.1);\n\n    .container {\n      max-width: 1024px;\n      margin: 0 auto;\n    }\n\n    .closing-content {\n      max-width: 900px;\n      margin: 0 auto;\n      position: relative;\n      z-index: 1;\n    }\n\n    .closing-statement {\n      font-family: \"Open Sans\", sans-serif !important;\n      font-size: 36px;\n      font-weight: 700;\n      margin-bottom: 32px;\n      line-height: 1.3;\n      letter-spacing: -0.5px;\n      color: #ffffff !important;\n\n      @media (max-width: 768px) {\n        font-size: 36px;\n        margin-bottom: 40px;\n      }\n    }\n\n    .cta-buttons {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 96px;\n\n      @media (min-width: 640px) {\n        flex-direction: row;\n      }\n    }\n\n    .btn-primary-cta {\n      font-family: \"Open Sans\", sans-serif !important;\n      padding: 20px 40px;\n      font-size: 20px;\n      font-weight: 700;\n      border-radius: 16px;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      background: #5ea1d8;\n      color: #ffffff;\n      box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.3);\n      width: 100%;\n\n      &:hover {\n        transform: translateY(-4px);\n      }\n\n      @media (min-width: 640px) {\n        width: auto;\n      }\n    }\n\n    .btn-secondary-cta {\n      font-family: \"Open Sans\", sans-serif !important;\n      padding: 20px 40px;\n      font-size: 20px;\n      font-weight: 700;\n      border-radius: 16px;\n      border: 1px solid rgba(226, 232, 240, 1);\n      cursor: pointer;\n      transition: all 0.3s ease;\n      background: #ffffff;\n      color: #212427;\n      width: 100%;\n\n      &:hover {\n        background: rgba(248, 250, 252, 1);\n      }\n\n      @media (min-width: 640px) {\n        width: auto;\n      }\n\n    }\n\n\n    .btn-primary,\n    .btn-secondary {\n      font-family: \"Open Sans\", sans-serif !important;\n      padding: 18px 45px;\n      font-size: 17px;\n      font-weight: 600;\n      border-radius: 8px;\n      border: none;\n      cursor: pointer;\n      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n      text-decoration: none;\n      display: inline-block;\n      letter-spacing: 0.5px;\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n      text-transform: uppercase;\n      min-width: 220px;\n    }\n\n    .btn-primary {\n      background: #ffffff;\n      color: #5ea1d8;\n      position: relative;\n      overflow: hidden;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 0;\n        height: 0;\n        border-radius: 50%;\n        background: rgba(94, 161, 216, 0.1);\n        transform: translate(-50%, -50%);\n        transition: width 0.6s ease, height 0.6s ease;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.95);\n        transform: translateY(-3px);\n        box-shadow: 0 8px 25px rgba(255, 255, 255, 0.4);\n\n        &::before {\n          width: 300px;\n          height: 300px;\n        }\n      }\n\n      &:active {\n        transform: translateY(-1px);\n      }\n    }\n\n    .btn-secondary {\n      background: transparent;\n      color: #ffffff;\n      border: 2px solid #ffffff;\n      position: relative;\n      overflow: hidden;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: -100%;\n        width: 100%;\n        height: 100%;\n        background: rgba(255, 255, 255, 0.1);\n        transition: left 0.4s ease;\n      }\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.15);\n        color: #ffffff;\n        transform: translateY(-3px);\n        box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);\n        border-color: rgba(255, 255, 255, 0.9);\n\n        &::before {\n          left: 0;\n        }\n      }\n\n      &:active {\n        transform: translateY(-1px);\n      }\n    }\n  }\n\n  // Footer\n  .footer {\n    background: #000000;\n    color: #ffffff;\n    padding: 14px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n\n    .copy-rights {\n      max-width: 1400px;\n      margin: 0 auto;\n      padding: 0 24px;\n      width: 100%;\n\n      .row {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        width: 100%;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 16px;\n        }\n      }\n\n      .col-md-5,\n      .col-md-7,\n      .col-12 {\n        padding: 0;\n        display: flex;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          width: 100%;\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-5 {\n        @media (min-width: 769px) {\n          justify-content: flex-start;\n        }\n      }\n\n      .col-md-7 {\n        @media (min-width: 769px) {\n          justify-content: flex-end;\n        }\n      }\n    }\n\n    .cpyrgt {\n      color: #64748b !important;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      font-size: 14px;\n      line-height: 1.5;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        flex-wrap: wrap;\n      }\n\n      li {\n        color: #64748b !important;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n\n        a {\n          color: #64748b !important;\n          text-decoration: none;\n          margin-left: 4px;\n\n          &:hover {\n            color: #5ea1d8 !important;\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .f-menu-right {\n      display: flex;\n      list-style: none;\n      padding: 0;\n      margin: 0;\n      align-items: center;\n      justify-content: flex-end;\n      flex-wrap: wrap;\n      gap: 0;\n      width: 100%;\n\n      @media (max-width: 768px) {\n        justify-content: flex-start;\n        flex-wrap: wrap;\n      }\n\n      li {\n        padding: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n\n        &:not(:last-child)::after {\n          content: '|';\n          color: rgba(100, 116, 139, 0.5);\n          margin: 0 12px;\n          font-size: 14px;\n        }\n\n        a {\n          color: #64748b !important;\n          font-size: 14px;\n          text-decoration: none;\n          transition: color 0.3s ease;\n          padding: 4px 0;\n          white-space: nowrap;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    h6 {\n      color: #94a3b8 !important;\n      font-weight: 700 !important;\n      font-size: 12px !important;\n      text-transform: uppercase !important;\n      letter-spacing: 0.1em !important;\n      margin-bottom: 16px !important;\n    }\n\n    ul {\n      li {\n        a {\n          color: #64748b !important;\n          font-size: 14px !important;\n\n          &:hover {\n            color: #5ea1d8 !important;\n          }\n        }\n      }\n    }\n\n    p {\n      color: #475569 !important;\n      font-size: 14px !important;\n    }\n\n    .material-symbols-outlined {\n      color: #475569 !important;\n\n      &:hover {\n        color: #ffffff !important;\n      }\n    }\n  }\n\n  // Animations\n  @keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes fadeInScale {\n    from {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  // Responsive Design\n  @media (max-width: 768px) {\n    .container {\n      padding: 0 16px;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      overflow-x: hidden;\n    }\n\n    .section {\n      padding: 60px 0;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      overflow-x: hidden;\n    }\n\n    .step-section,\n    .audience-section,\n    .why-section {\n      padding: 60px 0;\n      width: 100%;\n      max-width: 100%;\n      box-sizing: border-box;\n      overflow-x: hidden;\n    }\n\n    .sticky-nav {\n      .nav-links {\n        justify-content: flex-start;\n        padding: 12px 0;\n        gap: 6px;\n      }\n\n      .nav-link {\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 12px;\n        padding: 8px 14px;\n        border-radius: 4px;\n      }\n    }\n\n    .btn-primary,\n    .btn-secondary {\n      min-width: auto;\n      width: 100%;\n      padding: 16px 30px;\n      font-size: 16px;\n    }\n\n    .cta-buttons {\n      flex-direction: column;\n      gap: 12px;\n    }\n  }\n\n  // Tablet optimizations\n  @media (min-width: 769px) and (max-width: 1024px) {\n    .section {\n      padding: 70px 0;\n    }\n\n    .container {\n      padding: 0 30px;\n    }\n  }\n\n// Override global mobile footer hiding for How It Works page\n@media screen and (max-width: 992px) {\n  :host footer,\n  :host .footer,\n  app-how-it-works footer,\n  app-how-it-works .footer {\n    display: block !important;\n    visibility: visible !important;\n  }\n}\n\n// ============================================================\n// Light Mode Overrides\n// Rhythm: Blue hero → light steps → blue stakeholders → light why-matters → blue closing\n// ============================================================\nbody.theme-light {\n  .how-it-works-page {\n    background: #f8fafc !important;\n    color: #0f172a !important;\n\n    // ── Header ──────────────────────────────────────────────\n    .page-header {\n      background: rgba(255, 255, 255, 0.95) !important;\n      border-bottom-color: rgba(0, 0, 0, 0.08) !important;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n      backdrop-filter: blur(20px) !important;\n\n      &.scrolled {\n        background: rgba(255, 255, 255, 0.98) !important;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n      }\n\n      .menu-button {\n        color: #0f172a !important;\n        &:hover { background-color: rgba(0, 0, 0, 0.06) !important; }\n      }\n\n      .header-nav .nav-link {\n        color: rgba(15, 23, 42, 0.5) !important;\n        &:hover { color: #0f172a !important; }\n      }\n\n      .btn-get-started {\n        background: #5ea1d8 !important;\n        color: #ffffff !important;\n        font-weight: 700 !important;\n        &:hover {\n          background: #4a8cc5 !important;\n          box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35) !important;\n        }\n      }\n    }\n\n    // ── Hero Section — Flowchest blue ───────────────────────\n    .hero-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n      color: #ffffff !important;\n\n      .hero-radial-gradient {\n        background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.15) 0%, transparent 55%) !important;\n      }\n\n      .hero-decorative-line {\n        background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.4), transparent) !important;\n      }\n\n      .hero-content { color: #ffffff !important; }\n\n      .hero-title {\n        color: #ffffff !important;\n        .highlight-blue { color: rgba(255, 255, 255, 0.85) !important; }\n      }\n\n      .hero-description { color: rgba(255, 255, 255, 0.85) !important; }\n\n      .btn-primary-hero {\n        background: #ffffff !important;\n        color: #5ea1d8 !important;\n        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;\n        &:hover { transform: scale(1.05); }\n      }\n\n      .btn-secondary-hero {\n        background: rgba(255, 255, 255, 0.15) !important;\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.4) !important;\n        &:hover { background: rgba(255, 255, 255, 0.25) !important; }\n      }\n\n      .btn-watch-demo {\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.55) !important;\n        &:hover { background: rgba(255, 255, 255, 0.12) !important; }\n      }\n    }\n\n    // ── Six-Step Flow Section — light ────────────────────────\n    .six-step-flow-section {\n      background: #f8fafc !important;\n\n      .section-main-title { color: #0f172a !important; }\n      .title-underline    { background: #5ea1d8 !important; }\n\n      .steps-central-line { background: rgba(94, 161, 216, 0.2) !important; }\n\n      .step-item {\n        .step-number { -webkit-text-stroke-color: rgba(58, 122, 181, 0.55) !important; }\n\n        .step-title       { color: #5ea1d8 !important; }\n        .step-description { color: #475569 !important; }\n\n        .step-list-normal li {\n          color: #475569 !important;\n          &::marker { color: #5ea1d8 !important; }\n        }\n\n        .step-bullets li { color: #0f172a !important; }\n\n        .step-image-card {\n          border-color: rgba(94, 161, 216, 0.2) !important;\n          box-shadow: 0 20px 25px -5px rgba(94, 161, 216, 0.08), 0 10px 10px -5px rgba(94, 161, 216, 0.04) !important;\n        }\n      }\n    }\n\n    // ── Individual Step Sections — alternating light ─────────\n    .step-section {\n      background: #ffffff !important;\n\n      &:nth-child(even) { background: #f8fafc !important; }\n\n      .step-number { -webkit-text-stroke-color: rgba(58, 122, 181, 0.55) !important; }\n      .step-title       { color: #5ea1d8 !important; }\n      .step-description { color: #475569 !important; }\n      .step-bullets li  { color: #0f172a !important; }\n\n      .step-image-card { border-color: rgba(94, 161, 216, 0.2) !important; }\n\n      .body-copy        { color: #334155 !important; }\n      .step-features li { color: #334155 !important; }\n\n      .microcopy {\n        background: rgba(94, 161, 216, 0.07) !important;\n        border-left-color: #5ea1d8 !important;\n        p { color: #0f172a !important; }\n      }\n    }\n\n    // ── Stakeholders Section — Flowchest blue ────────────────\n    .stakeholders-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n      color: #ffffff !important;\n\n      .section-main-title { color: #ffffff !important; }\n      .section-subtitle   { color: rgba(255, 255, 255, 0.82) !important; }\n\n      .stakeholder-card {\n        background: rgba(255, 255, 255, 0.12) !important;\n        border-color: rgba(255, 255, 255, 0.2) !important;\n\n        &:hover {\n          border-color: rgba(255, 255, 255, 0.45) !important;\n          background: rgba(255, 255, 255, 0.18) !important;\n        }\n\n        .stakeholder-icon-wrapper {\n          background: rgba(255, 255, 255, 0.2) !important;\n          color: #ffffff !important;\n        }\n\n        &:hover .stakeholder-icon-wrapper {\n          background: rgba(255, 255, 255, 0.35) !important;\n        }\n\n        .stakeholder-title       { color: #ffffff !important; }\n        .stakeholder-description { color: rgba(255, 255, 255, 0.82) !important; }\n\n        .stakeholder-watch-btn {\n          color: #ffffff !important;\n          border-color: rgba(255, 255, 255, 0.4) !important;\n          &:hover {\n            background: rgba(255, 255, 255, 0.15) !important;\n            border-color: rgba(255, 255, 255, 0.65) !important;\n            color: #ffffff !important;\n          }\n        }\n      }\n    }\n\n    // ── Why Matters Section — light ──────────────────────────\n    .why-matters-section {\n      background: #f8fafc !important;\n\n      .section-main-title    { color: #0f172a !important; }\n      .feature-description   { color: #334155 !important; }\n      .why-card-description  { color: #334155 !important; }\n      .why-matters-microcopy { color: #475569 !important; }\n\n      .why-card {\n        &.sustainability-card,\n        &.precision-card {\n          background: rgba(94, 161, 216, 0.06) !important;\n          border-color: rgba(94, 161, 216, 0.18) !important;\n        }\n      }\n\n      .feature-header {\n        color: #0f172a !important;\n        .feature-icon-small,\n        .feature-label { color: #0f172a !important; }\n      }\n\n      .why-card-title {\n        color: #0f172a !important;\n        .feature-icon-small,\n        .feature-label { color: #0f172a !important; }\n      }\n\n      .stat-card {\n        background: rgba(94, 161, 216, 0.06) !important;\n        border-color: rgba(94, 161, 216, 0.15) !important;\n        .stat-label { color: #64748b !important; }\n      }\n\n      .precision-feature-item {\n        background: rgba(94, 161, 216, 0.06) !important;\n        border-color: rgba(94, 161, 216, 0.15) !important;\n        .precision-text { color: #0f172a !important; }\n      }\n    }\n\n    // ── Why Section (solid blue band) — unchanged ────────────\n    .why-section {\n      .body-copy        { color: rgba(255, 255, 255, 0.95) !important; }\n      .step-features li { color: rgba(255, 255, 255, 0.95) !important; }\n    }\n\n    // ── Closing / CTA Section — Flowchest blue ───────────────\n    .closing-section {\n      background: linear-gradient(160deg, #90c3e8 0%, #70aedf 55%, #5ea1d8 100%) !important;\n      border-top: none !important;\n      color: #ffffff !important;\n\n      .closing-statement { color: #ffffff !important; }\n\n      .btn-primary-cta {\n        background: #ffffff !important;\n        color: #5ea1d8 !important;\n        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15) !important;\n        &:hover { transform: translateY(-4px); }\n      }\n\n      .btn-secondary-cta {\n        background: rgba(255, 255, 255, 0.15) !important;\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.4) !important;\n        &:hover { background: rgba(255, 255, 255, 0.25) !important; }\n      }\n\n      // Legacy button classes\n      .btn-primary {\n        background: #ffffff !important;\n        color: #5ea1d8 !important;\n        &:hover { background: rgba(255, 255, 255, 0.92) !important; }\n      }\n\n      .btn-secondary {\n        background: rgba(255, 255, 255, 0.12) !important;\n        color: #ffffff !important;\n        border-color: rgba(255, 255, 255, 0.35) !important;\n        &:hover { background: rgba(255, 255, 255, 0.22) !important; }\n      }\n    }\n\n    // ── Footer ───────────────────────────────────────────────\n    .footer {\n      background: #f1f5f9 !important;\n      color: #475569 !important;\n      border-top-color: rgba(0, 0, 0, 0.08) !important;\n\n      .cpyrgt li,\n      .cpyrgt li a,\n      .f-menu-right li a { color: #64748b !important; }\n\n      .cpyrgt li a:hover,\n      .f-menu-right li a:hover { color: #5ea1d8 !important; }\n\n      .material-symbols-outlined {\n        color: #94a3b8 !important;\n        &:hover { color: #5ea1d8 !important; }\n      }\n    }\n\n    // Generic section headings\n    .section-heading    { color: #0f172a !important; }\n    .section-main-title { color: #0f172a !important; }\n  }\n\n  // Video modal stays dark for video contrast\n  .video-modal-card {\n    background: #0f172a !important;\n  }\n}\n\n// Video Modal Styles\n.video-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n\n.video-modal-card {\n  background: #0f172a;\n  border-radius: 16px;\n  max-width: 90vw;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  animation: slideUp 0.3s ease;\n  border: 1px solid rgba(94, 161, 216, 0.2);\n\n  @keyframes slideUp {\n    from {\n      opacity: 0;\n      transform: translateY(30px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @media (min-width: 768px) {\n    max-width: 900px;\n  }\n}\n\n.video-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n\n  h4 {\n    font-family: \"Open Sans\", sans-serif !important;\n    font-size: 20px;\n    font-weight: 700;\n    color: #ffffff !important;\n    margin: 0;\n  }\n\n  .icon-button {\n    background: transparent;\n    border: none;\n    color: #ffffff;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n.video-modal-body {\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  overflow: hidden;\n\n  .demo-video {\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    background: #000000;\n    outline: none;\n\n    @media (max-width: 768px) {\n      max-height: 60vh;\n    }\n\n    &.demo-video-iframe {\n      aspect-ratio: 16 / 9;\n      min-height: 320px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
